<template>
  <div id="expenseItemComponent">
    <v-layout style="width:100%">
      <page-title style="width:18%" :heading="heading" :subheading="subheading" :icon="icon"></page-title>
      <div v-if="isVisibleInputsAmount" style="padding-left:9%; width:57%; " class="">
        <b-row>
          <b-col class="px-2" col-md-6 col-xl-4>
            <b-card style="height:40px" class="pa-0 widget-content bg-heavy-rain">
              <div class="widget-content-wrapper ">
                <div class="widget-content-left">
                  <div class="widget-heading">{{ typeExpenseInput }}</div>
                  <!-- <div class="widget-subheading">{{$t('dashboard.')}}:</div> -->
                </div>
                <div class="widget-content-right">
                  <div class="widget-numbers">${{ expenseAdvance }}</div>
                </div>
              </div>
            </b-card>
          </b-col>
          <b-col class="px-2" col-md-6 col-xl-4>
            <b-card style="height:40px" class="pa-0 widget-content bg-heavy-rain">
              <div class="widget-content-wrapper ">
                <div class="widget-content-left">
                  <div class="widget-heading">{{  expenseToCheckedInput }}</div>
                  <!-- <div class="widget-subheading">{{$t('dashboard.')}}:</div> -->
                </div>
                <div class="widget-content-right">
                  <div class="widget-numbers " >${{ checked }}</div>
                </div>
              </div>
            </b-card>
          </b-col>
        </b-row>
        <b-row style="padding-top: 6px;">
          <b-col class="px-2" col-md-6 col-xl-4>
            <b-card style="height:40px" class="pa-0 widget-content bg-heavy-rain">
              <div class="widget-content-wrapper ">
                <div class="widget-content-left">
                  <div class="widget-heading">{{ expenseCheckedInput }}</div>
                  <!-- <div class="widget-subheading">{{$t('dashboard.' )}}:</div> -->
                </div>
                <div class="widget-content-right">
                  <div class="widget-numbers ">${{ toCheck }}</div>
                </div>
              </div>
            </b-card>
          </b-col>
          <b-col v-if="isVisibleInputsAmountAmex" class="px-2" col-md-6 col-xl-4>
            <b-card style="height:40px" class="pa-0 widget-content bg-heavy-rain">
              <div class="widget-content-wrapper ">
                <div class="widget-content-left">
                  <div class="widget-heading">{{ expenseIsAmex }}</div>
                </div>
                <div class="widget-content-right">
                  <div class="widget-numbers ">${{ expenseIsAmexAmount }}</div>
                </div>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </v-layout>
    <v-container>
      <v-layout class="mb-3" xs12 v-if="getTotalPending > 0">
        <v-card>
          <v-card-text class="d-flex flex-row">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  size="36"
                  class="mx-0 px-0"
                  style="color: orange"
                  v-on="on"
                >
                  mdi-alert-circle-outline
                </v-icon>
              </template>
              <span>
                {{ $t('expenses.categoriesPending') }}:
                <ul>
                  <li v-for="category in categoriesPending" :key="category.id">
                    {{ category.name }}
                  </li>
                </ul>
              </span>
            </v-tooltip>
            <h3 class="subtitle-2 mt-2 ml-1" style="color: tomato">
              {{
                $t('expenses.categoriesPendingMessage', {
                  pending: getTotalPending,
                })
              }}
            </h3>
          </v-card-text>
        </v-card>
      </v-layout>
      <v-layout>
        <v-flex>
          <v-btn @click="$router.go(-1)" color="primary" outline round>
            <v-icon left>undo</v-icon>{{ $t('general.back') }}
          </v-btn>
          <v-btn
            v-if="
              loadExpense &&
              expense.travel_expenses_request &&
              expense.travel_expenses_request !== null
            "
            round
            outline
            slot="activator"
            color="primary"
            :loading="loadingDownload"
            :disabled="loadingDownload"
            @click="downloadRequest(expense)"
          >
            <v-icon left>fas fa-file-invoice-dollar</v-icon>
            {{ $t('viatics.downloadRequest') }}
          </v-btn>
        </v-flex>
        <v-flex v-if="isVoucherBlue" style="width: 55%;">
          <v-alert :value="true" type="info" style="padding: 5px; border-radius: 5px; ">
              {{ $t('expenses.blueVoucher.warning') }}
          </v-alert>
        </v-flex>
        <v-flex>
          <div v-html="checkExpensesMessage()"></div>
        </v-flex>
        <v-flex  class="text-xs-right">
          <!-- FISCAL -->
          <v-dialog v-model="dialogXML" max-width="700px" scrollable persistent>
            <!-- v-show="expense && expense.type === null" -->
            <v-btn v-show="viewBtnExpenseAdd && expense && viewCfdi" round outline slot="activator" color="primary">
              <v-icon left>attach_money</v-icon> CFDI (XML)
            </v-btn>
            <v-card>
              <v-toolbar flat>
                <h2 class="font-weight-black primary--text mb-0">CFDI (XML)</h2>
              </v-toolbar>
              <v-card-text>
                <v-form ref="formXML" lazy-validation>
                  <v-container v-if="selectXml">
                    <v-layout>
                      <v-flex xs-12>
                        <vue-dropzone
                          ref="dropzoneXML"
                          id="dropzoneXML"
                          :options="dropzoneOptionsXML"
                          v-on:vdropzone-added="fileAddedXml"
                          v-on:vdropzone-error="fileUploadError"
                          v-on:vdropzone-success="xmlUpload"
                          v-on:vdropzone-queue-complete="xmlQueueComplete">
                        </vue-dropzone>
                        <v-progress-linear v-if="loadingFile" :indeterminate="loadingFile"></v-progress-linear>
                      </v-flex>
                    </v-layout>
                  </v-container>
                  <v-container v-if="uploadedXML && uploadIndex > -1 && !readXml">
                    <v-layout row wrap>
                      <p>{{ $t('expenseItems.readItemProgress', { current: uploadIndex + 1, total: uploadedXML.length }) }}</p>
                    </v-layout>
                  </v-container>
                  <v-container v-if="readXml">
                    <v-layout row wrap>
                      <v-flex class="d-flex" xs12>
                        <v-text-field v-model="editedItem.emisor" style="width: 80%" :label="'Emisor'" :error-messages="errors.uuid" readonly/>
                        <v-tooltip right>
                          <template v-slot:activator="{ on }">
                            <v-icon color="primary" v-on="on">verified</v-icon>
                          </template>
                          <span>{{ $t('expenseItems.verifyEFOMsg') }}</span>
                        </v-tooltip>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field v-model="editedItem.uuid" :label="$t('general.uuid')" :error-messages="errors.uuid" readonly></v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field v-model="editedItem.date" :label="$t('general.date')" :error-messages="errors.date" prepend-icon="event" readonly></v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-autocomplete v-model="editedItem.gst_categories" :label="$t('general.category')" :items="categories" item-text="name" item-value="id" :error-messages="errors.gst_categories" :rules="rules.required" return-object>
                          <template slot="selection" slot-scope="data">
                            {{ data.item.name }}
                          </template>
                          <template slot="item" slot-scope="data">
                            {{ data.item.name }}
                          </template>
                        </v-autocomplete>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field v-model="editedItem.country.descripcion" :error-messages="errors.country" :label="$t('general.country')" readonly></v-text-field>
                      </v-flex>
                      <v-flex v-if="hasMultiProjects && expense.multiprojects && expense.multiprojects.length > 0" xs12 md6>
                        <v-autocomplete v-model="editedItem.project_id" :label="$t('general.project')" :items="expense.multiprojects" item-value="id" item-text="name" :error-messages="errors.project_id" :rules="rules.required"></v-autocomplete>
                      </v-flex>
                      <v-flex v-if="applyFeatures" md12>
                      <v-list>
                        <v-list-tile @click="expandMenu = !expandMenu">
                            <v-list-tile-content>
                              <v-list-tile-title>
                                <h3 class="font-weight-black primary--text mb-0">
                                  {{ $t('general.concepts') }}
                                </h3>
                              </v-list-tile-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                              <v-icon v-text="expandMenu ? 'mdi-chevron-up' : 'mdi-chevron-down'"></v-icon>
                            </v-list-tile-action>
                        </v-list-tile>
                      </v-list>
                      <v-list v-show="expandMenu">
                        <v-container>
                          <v-form ref="formXMLConcepts" lazy-validation>
                            <v-data-table
                              style="width: 100%;"
                              :headers="conceptsHeader"
                              :items="editedItem.conceptos"
                              loading-text="Cargando contenido"
                              no-data-text="No hay datos que mostrar"
                              hide-actions>
                              <template v-slot:items="props">
                                <tr>
                                    <td class="text-sm-left text-truncate" style="width: 45%">
                                      <v-text-field
                                        outlined
                                        dense
                                        :hide-details="true"
                                        color="primary"
                                        v-model="props.item.Descripcion"
                                        :disabled="true"/>
                                    </td>
                                    <td style="width: 20%">
                                      <v-text-field
                                        outlined
                                        dense
                                        :hide-details="true"
                                        color="primary"
                                        v-model="props.item.Importe"
                                        :disabled="true"/>
                                    </td>
                                    <td style="width: 35%" class="text-sm-center">
                                      <v-autocomplete class="text-sm-center" :label="$t('general.category')" v-model="props.item.gst_category_id" item-text="name" item-value="id" dense hide-details  :rules="rules.required" :items="categoriesOrder"  color="primary"/>
                                    </td>
                                </tr>
                              </template>
                            </v-data-table>
                          </v-form>
                        </v-container>
                      </v-list>
                      </v-flex>
                      <v-flex xs12>
                        <v-textarea
                          v-model="editedItem.description"
                          :error-messages="errors.description"
                          :label="$t('general.description')"
                        ></v-textarea>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          v-model="editedItem.currency.descripcion"
                          :error-messages="errors.currency"
                          :label="$t('general.currency')"
                          readonly
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          v-model="editedItem.exchange"
                          :label="$t('general.exchangeRate')"
                          :error-messages="errors.exchange"
                          :rules="
                            rules.required && rules.decimal && rules.exchange
                          "
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          v-model="editedItem.subtotal"
                          :label="$t('general.subtotal')"
                          :error-messages="errors.subtotal"
                          readonly
                        ></v-text-field>
                      </v-flex>
                      <v-flex>
                        <v-text-field
                          v-model="editedItem.discount"
                          :label="$t('general.discount')"
                          :error-messages="errors.discount"
                          readonly
                        ></v-text-field>
                      </v-flex>
                      <v-flex>
                        <v-text-field
                          v-model="editedItem.total"
                          :label="$t('general.total')"
                          :error-messages="errors.total"
                          readonly
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          v-model="editedItem.sat_forma_pago.descripcion"
                          :label="$t('general.formaPago')"
                          :error-messages="errors.sat_formaPago_id"
                          readonly
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          v-model="editedItem.sat_metodo_pago.descripcion"
                          :label="$t('general.metodoPago')"
                          :error-messages="errors.sat_metodoPago_id"
                          readonly
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          v-model="editedItem.folio"
                          :error-messages="errors.folio"
                          :label="$t('general.folioRef')"
                          readonly
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-textarea
                          v-model="editedItem.comment"
                          :label="$t('general.comment')"
                          :error-messages="errors.comment"
                          :rules="commentE ? [v => !!v || $t('validation.required')] : []"
                        ></v-textarea>
                      </v-flex>
                    </v-layout>
                  </v-container>
                  <v-container>
                    <v-flex xs12 v-if="editedItem.gst_categories.name === 'comida' ||  editedItem.gst_categories.name === 'Hotel' || editedItem.gst_categories.name === 'hotel' || editedItem.gst_categories.name === 'Alimento' || editedItem.gst_categories.name === 'Alimentos' || editedItem.gst_categories.name === 'alimento' || editedItem.gst_categories.name === 'alimentos'">
                      <v-checkbox
                        v-model="editedItem.hasTip"
                        :error-messages="errors.hasTip"
                        label="Desea agregar propina al gasto?"
                      ></v-checkbox>
                    </v-flex>
                    <v-flex
                      xs6
                      v-if="
                        editedItem.hasTip && editedItem.gst_categories.name === 'comida' || editedItem.hasTip && editedItem.gst_categories.name === 'Hotel' || editedItem.hasTip && editedItem.gst_categories.name === 'hotel' || editedItem.hasTip && editedItem.gst_categories.name === 'Alimento' || editedItem.hasTip && editedItem.gst_categories.name === 'Alimentos' || editedItem.hasTip && editedItem.gst_categories.name === 'alimento' || editedItem.hasTip && editedItem.gst_categories.name === 'alimentos'
                      "
                    >
                      <v-text-field
                        type="number"
                        v-model="editedItemTip.amount"
                        :error-messages="errors.amount"
                        :label="$t('general.amount')"
                      ></v-text-field>
                    </v-flex>
                    <v-flex
                      xs12
                      v-if="
                        editedItem.hasTip && editedItem.gst_categories.name === 'comida' || editedItem.hasTip && editedItem.gst_categories.name === 'Hotel' || editedItem.hasTip && editedItem.gst_categories.name === 'hotel' || editedItem.hasTip && editedItem.gst_categories.name === 'Alimento' || editedItem.hasTip && editedItem.gst_categories.name === 'Alimentos' || editedItem.hasTip && editedItem.gst_categories.name === 'alimento' || editedItem.hasTip && editedItem.gst_categories.name === 'alimentos'
                      "
                    >
                      <vue-dropzone
                        ref="dropzone"
                        id="dropzone"
                        :options="dropzoneOptions"
                        v-on:vdropzone-file-added="fileAdded"
                        v-on:vdropzone-error="fileUploadError"
                        v-on:vdropzone-success="fileUploadTip"
                      >
                      </vue-dropzone>
                    </v-flex>
                  </v-container>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="closeDialogXML()" round color="primary darken-1" flat>
                  {{ $t('general.cancel') }}
                </v-btn>
                <v-btn v-if="readXml" round color="warning" flat @click="resetXML()">
                  {{ $t('general.reset') }}
                </v-btn>
                <v-btn v-if="readXml && !nextXml" @click="submitXML()" round color="primary" :loading="loading" :disabled="loading">
                  {{ submitXMLButton }}
                </v-btn>
                <v-btn v-if="nextXml" @click="showNextUpload()" round color="success" :loading="loading" :disabled="loading">
                  {{ $t('general.NextXml') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- NO FISCAL -->
          <v-btn v-show="viewBtnExpenseAdd && expense && viewRecipt" round outline slot="activator" color="primary" @click="openReceiptDialog">
              <v-icon left>attach_money</v-icon> {{ $t('general.receipt') }}
          </v-btn>
          <v-dialog  v-model="dialog" max-width="700px" scrollable persistent>
            <v-card>
              <v-toolbar flat>
                <h2 class="font-weight-black primary--text mb-0">{{ formTitle }}</h2>
              </v-toolbar>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-alert
                      :value="error"
                      color="error"
                      icon="warning"
                      outline
                      transition="scale-transition"
                    >
                      {{ errorMessage }}
                    </v-alert>
                    <v-form ref="form" lazy-validation>
                      <v-container>
                        <v-layout row wrap>
                          <v-flex xs12 md6>
                            <v-menu
                              v-model="datemenu"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              lazy
                              transition="scale-transition"
                              offset-y
                              full-width
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  v-model="editedItem.date"
                                  :label="$t('general.date')"
                                  prepend-icon="event"
                                  readonly
                                  v-on="on"
                                  :rules="rules.required"
                                  :error-messages="errors.date"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                color="primary"
                                :locale="$t('general.locale')"
                                v-model="editedItem.date"
                                @input="datemenu = false"
                                :min="expense.start_date"
                                :max="expense.end_date"
                              >
                              </v-date-picker>
                            </v-menu>
                          </v-flex>
                          <v-flex xs12 md6>
                            <v-autocomplete
                              v-model="editedItem.gst_categories_id"
                              :label="$t('general.category')"
                              :items="categoriesOrder"
                              :disabled="loadingCategories"
                              :loading="loadingCategories"
                              item-text="name"
                              item-value="id"
                              item-disabled="disableds"
                              :error-messages="errors.gst_categories_id"
                              :rules="rules.required"
                            >
                              <template slot="selection" slot-scope="data">
                                {{ data.item.name }}
                              </template>
                              <template slot="item" slot-scope="data">
                                {{ data.item.name }}
                                <span
                                  class="ml-3 mt-2"
                                  style="color: #88d77a"
                                  v-if="getPendingByCategory(data.item.id) > 0"
                                >
                                  <h6>
                                    {{ getPendingByCategory(data.item.id) }}
                                    {{ $t('expenses.toRelate') }}
                                  </h6>
                                </span>
                              </template>
                            </v-autocomplete>
                          </v-flex>
                          <v-flex xs12 md6>
                            <v-autocomplete v-model="editedItem.country.id" :label="$t('general.country')" :items="items" :filter="dataArrayFilter.filter" item-value="id" item-text="descripcion" :error-messages="errors.country" :rules="rules.required" cache-items flat hide-details auto-select-first clearable>
                              <template slot="selection" slot-scope="data">
                                {{ data.item.c_Pais }} -
                                {{ data.item.descripcion }}
                              </template>
                              <template slot="item" slot-scope="data">
                                {{ data.item.c_Pais }} -
                                {{ data.item.descripcion }}
                              </template>
                            </v-autocomplete>
                          </v-flex>
                          <v-flex v-if="hasMultiProjects && expense.multiprojects && expense.multiprojects.length > 0" xs12 md6>
                            <v-autocomplete v-model="editedItem.project_id" :label="$t('general.project')" :items="expense.multiprojects" item-value="id" item-text="name" :error-messages="errors.project_id" :rules="rules.required"></v-autocomplete>
                          </v-flex>
                          <v-flex xs12>
                            <v-textarea
                              v-model="editedItem.description"
                              :label="$t('general.description')"
                              :error-messages="errors.description"
                              :rules="rules.required"
                            >
                            </v-textarea>
                          </v-flex>
                          <v-flex xs12 md6>
                            <v-autocomplete
                              clearable
                              v-model="editedItem.currency"
                              :label="$t('general.currency')"
                              :error-messages="errors.currency"
                              :items="satMoneda"
                              item-text="descripcion"
                              item-value="id"
                              :filter="currencyFilter"
                              :rules="rules.required"
                              return-object
                            >
                              <template slot="selection" slot-scope="data">
                                {{ data.item.c_Moneda }} -
                                {{ data.item.descripcion }}
                              </template>
                              <template slot="item" slot-scope="data">
                                {{ data.item.c_Moneda }} -
                                {{ data.item.descripcion }}
                              </template>
                            </v-autocomplete>
                          </v-flex>
                          <v-flex xs12 md6>
                            <v-text-field
                              :readonly="setMXN"
                              v-model="editedItem.exchange"
                              :label="$t('general.exchangeRate')"
                              :error-messages="errors.exchange"
                              :rules="
                                rules.required &&
                                rules.decimal &&
                                rules.exchange
                              "
                            >
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12 md5>
                            <v-text-field
                              v-model="editedItem.subtotal"
                              :label="$t('general.subtotal')"
                              :error-messages="errors.subtotal"
                              :rules="rules.required && rules.decimal"
                              @keyup="getTotal(1)"
                            >
                              <v-tooltip slot="append" bottom>
                                <v-icon slot="activator" color="grey" dark
                                  >mdi-help-circle</v-icon
                                >
                                <span>{{ $t('expenses.amountMessage') }}</span>
                              </v-tooltip>
                            </v-text-field>
                            <p class="caption">
                              {{
                                amountMXN(
                                  editedItem.subtotal,
                                  editedItem.exchange
                                ) > 0.0
                                  ? '$' +
                                    amountMXN(
                                      editedItem.subtotal,
                                      editedItem.exchange
                                    ) +
                                    ' ' + tagMoneda
                                  : ''
                              }}
                            </p>
                          </v-flex>
                          <v-flex xs1 md2></v-flex>
                          <v-flex xs12 md5>
                            <v-text-field
                              v-model="editedItem.total"
                              :label="$t('general.total')"
                              :error-messages="errors.total"
                              :rules="rules.required && rules.decimal"
                              @keyup="getTotal(2)"
                            >
                              <v-tooltip slot="append" bottom>
                                <v-icon slot="activator" color="grey" dark
                                  >mdi-help-circle</v-icon
                                >
                                <span>{{ $t('expenses.amountMessage') }}</span>
                              </v-tooltip>
                            </v-text-field>
                            <p class="caption">
                              {{
                                amountMXN(
                                  editedItem.total,
                                  editedItem.exchange
                                ) > 0.0
                                  ? '$' +
                                    amountMXN(
                                      editedItem.total,
                                      editedItem.exchange
                                    ) +
                                    ' ' + tagMoneda
                                  : ''
                              }}
                            </p>
                          </v-flex>
                          <v-flex xs12 md6>
                            <v-select
                            v-model="editedItem.sat_forma_pago"
                            :label="$t('general.formaPago')"
                            :items="filteredSatFormaPago"
                            item-text="descripcion"
                            item-value="id"
                            :rules="rules.required"
                            :error-messages="errors.sat_formaPago_id"
                            return-object
                          >
                          </v-select>
                          </v-flex>
                          <v-flex xs12 md6>
                            <v-text-field
                              v-model="editedItem.folio"
                              :error-messages="errors.folio"
                              :label="
                                $t('general.folioRef') +
                                $t('general.optionalField')
                              "
                            >
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-textarea
                              v-model="editedItem.comment"
                              :label="
                                $t('general.comment') +
                                $t('general.optionalField')
                              "
                              :error-messages="errors.comment"
                            >
                            </v-textarea>
                          </v-flex>
                          <v-flex xs12 v-if="isAdding">
                            <vue-dropzone
                              ref="dropzoneNfiscal"
                              id="dropzone"
                              :options="dropzoneOptions"
                              v-on:vdropzone-file-added="fileAdded"
                              v-on:vdropzone-error="fileUploadError"
                              v-on:vdropzone-success="fileUpload"
                            >
                            </vue-dropzone>
                          </v-flex>
                          <v-flex xs12>
                          <v-container v-if="editedIndex > -1">
                          <label>{{ $t('general.image') }}:</label>
                          <v-btn
                          v-if="!isPDF(dataURL)"
                          depressed
                          color="primary"
                          block
                          @click="viewImg = !viewImg"
                        >
                          <v-icon left>{{
                            viewImg === false ? 'visibility' : 'visibility_off'
                          }}</v-icon>
                          {{
                            viewImg === false
                              ? $t('workflowValidation.showImage')
                              : $t('workflowValidation.hideImage')
                          }}
                        </v-btn>
                        <v-btn
                          block
                          v-if="isPDF(dataURL)"
                          @click="openPDF()"
                          color="primary"
                          depressed
                        >
                          <v-icon left>insert_drive_file</v-icon>
                          {{ $t('expenseItems.watchFile') }}
                        </v-btn>
                        <div v-if="viewImg === true">
                          <a v-if="!isPDF(dataURL)" @click="openPDF()">
                            <zoom-on-hover
                              :img-normal="dataURL"
                            ></zoom-on-hover>
                          </a>
                        </div>
                        <label>{{
                          $t('workflowValidation.changeImage')
                        }}</label>
                        </v-container>
                        <vue-dropzone
                        v-if="editedIndex > -1"
                          ref="dropzoneNfiscal"
                          id="dropzone"
                          :options="dropzoneOptions"
                          v-on:vdropzone-file-added="fileAdded"
                          v-on:vdropzone-error="fileUploadError"
                          v-on:vdropzone-success="fileUpload"
                        >
                        </vue-dropzone>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-form>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn round flat color="primary darken-1" @click="closeDialog()"> {{ $t('general.cancel') }} </v-btn>
                <v-btn v-if="!editedItem.id || editedItem.id === 0" round color="warning" flat @click="reset()"> {{ $t('general.clean') }} </v-btn>
                <v-btn round color="primary" :loading="loading" :disabled="loading" @click="submit()"> {{ editedItem.id && editedItem.id > 0 ? $t('general.save') : $t('general.charge') }} </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- GASTOS UNIVERSALES -->
          <v-btn v-show="viewBtnExpenseAdd && expense && viewExpenseUniversal" round outline slot="activator" color="primary" @click="openDialogUniversalExpense">
            <v-icon left>attach_money</v-icon>{{ $t('general.receiptUniversal') }}
          </v-btn>
          <v-dialog v-model="dialogUniversalExpense" max-width="700px" scrollable persistent>
            <v-card>
              <v-toolbar flat>
                <h2 class="font-weight-black primary--text mb-0">
                  {{ $t('general.receiptUniversal') }}
                </h2>
              </v-toolbar>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-alert
                      :value="error"
                      color="error"
                      icon="warning"
                      outline
                      transition="scale-transition"
                    >
                      {{ errorMessage }}
                    </v-alert>
                    <v-form ref="formExpenseUniversal" lazy-validation>
                      <v-container>
                        <v-layout row wrap>
                          <v-flex xs12 md4>
                            <v-menu
                              v-model="dateMenuUniversal"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              lazy
                              transition="scale-transition"
                              offset-y
                              full-width
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  v-model="editedItemReceiptUniversal.date"
                                  :label="$t('general.date')"
                                  prepend-icon="event"
                                  readonly
                                  v-on="on"
                                  :rules="rules.required"
                                  :error-messages="errors.date"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                color="primary"
                                :locale="$t('general.locale')"
                                v-model="editedItemReceiptUniversal.date"
                                @input="dateMenuUniversal = false"
                                :min="expense.start_date"
                                :max="expense.end_date"
                              >
                              </v-date-picker>
                            </v-menu>
                          </v-flex>
                          <v-flex xs12 md4>
                            <v-autocomplete v-model="editedItemReceiptUniversal.country.id" :items="items" :label="$t('general.country')" :error-messages="errors.country" item-value="id" item-text="descripcion" :rules="rules.required" :filter="dataArrayFilter.filter" cache-items flat hide-details auto-select-first clearable>
                              <template slot="selection" slot-scope="data">
                                {{ data.item.c_Pais }} -
                                {{ data.item.descripcion }}
                              </template>
                              <template slot="item" slot-scope="data">
                                {{ data.item.c_Pais }} -
                                {{ data.item.descripcion }}
                              </template>
                            </v-autocomplete>
                          </v-flex>
                          <v-flex xs12 md4>
                            <v-autocomplete
                              v-model="editedItemReceiptUniversal.gst_categories_id"
                              :label="$t('general.category')"
                              :items="categoriesOrder"
                              :disabled="loadingCategories"
                              :loading="loadingCategories"
                              item-text="name"
                              item-value="id"
                              item-disabled="disableds"
                              :error-messages="errors.gst_categories_id"
                              :rules="rules.required"
                            >
                              <template slot="selection" slot-scope="data">
                                {{ data.item.name }}
                              </template>
                              <template slot="item" slot-scope="data">
                                {{ data.item.name }}
                                <span
                                  class="ml-3 mt-2"
                                  style="color: #88d77a"
                                  v-if="getPendingByCategory(data.item.id) > 0"
                                >
                                  <h6>
                                    {{ getPendingByCategory(data.item.id) }}
                                    {{ $t('expenses.toRelate') }}
                                  </h6>
                                </span>
                              </template>
                            </v-autocomplete>
                          </v-flex>
                          <v-flex xs12 md3>
                            <v-combobox
                            v-if="editedItemReceiptUniversal.id === 0"
                              v-model="editedItemReceiptUniversal.vendorSelect"
                              :items="vendors"
                              :label="$t('general.supplier')"
                              :error-messages="errors.vendorSelect"
                              :rules="rules.required"
                              item-text="name"
                              item-value="id"
                              deletable-chips
                              hide-selected
                              @change="handleAutocompleteInput">
                            </v-combobox>
                            <v-autocomplete
                            v-else
                            v-model="editedItemReceiptUniversal.vendor.id"
                              :items="vendors"
                              :label="$t('general.supplier')"
                              :error-messages="errors.vendorSelect"
                              :rules="rules.required"
                              item-text="name"
                              item-value="id"
                              deletable-chips
                              hide-selected
                              @change="handleAutocompleteInputEdit">
                            </v-autocomplete>
                          </v-flex>
                          <v-flex xs12 md3>
                            <v-checkbox
                            color="primary"
                            v-model="editedItemReceiptUniversal.vendor.is_foreign"
                            :label="$t('general.is_national')"
                            :disabled="editedItemReceiptUniversal.id > 0 || disabledCheckIsNational"
                            @change="handleCheckboxChange()"/>
                          </v-flex>
                          <v-flex xs12 md3>
                            <v-text-field v-if="editedItemReceiptUniversal.vendor.is_foreign"
                              v-model="editedItemReceiptUniversal.vendor.tax_id"
                              :label="$t('general.ruc')"
                              :error-messages="errors.vendor_tax_id"
                              :rules="rules.required && rules.maxChars30"
                              :disabled="editedItemReceiptUniversal.id > 0 || editedItemReceiptUniversal.vendor.id > 0">
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12 md3>
                            <v-text-field v-if="editedItemReceiptUniversal.vendor.is_foreign"
                              v-model="editedItemReceiptUniversal.vendor.tax_id_validation_number"
                              :label="$t('general.dv')"
                              :error-messages="errors.tax_id_validation_number"
                              :rules="rules.required && rules.maxChars10"
                              :disabled="editedItemReceiptUniversal.id > 0 || editedItemReceiptUniversal.vendor.id > 0">
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12 md6>
                            <v-autocomplete
                              clearable
                              v-model="editedItemReceiptUniversal.currency"
                              :label="$t('general.currency')"
                              :error-messages="errors.currency"
                              :items="satMoneda"
                              item-text="descripcion"
                              item-value="id"
                              :filter="currencyFilter"
                              :rules="rules.required"
                              return-object
                              @change="seletectingCurrency">
                              <template slot="selection" slot-scope="data">
                                {{ data.item.c_Moneda }} -
                                {{ data.item.descripcion }}
                              </template>
                              <template slot="item" slot-scope="data">
                                {{ data.item.c_Moneda }} -
                                {{ data.item.descripcion }}
                              </template>
                            </v-autocomplete>
                          </v-flex>
                          <v-flex xs12 md3>
                            <v-text-field
                              :readonly="setMXN"
                              v-model="editedItemReceiptUniversal.exchange"
                              :label="$t('general.exchangeRate') + ' ' + typeChange"
                              :error-messages="errors.exchange"
                              :rules="
                                rules.required &&
                                rules.decimal &&
                                rules.exchange"
                              @input="handleInputExchange(editedItemReceiptUniversal)">
                            </v-text-field>
                          </v-flex>
                          <v-flex v-if="hasMultiProjects && expense.multiprojects && expense.multiprojects.length > 0" xs12 md12>
                            <v-autocomplete v-model="editedItemReceiptUniversal.project_id" :label="$t('general.project')" :items="expense.multiprojects" item-value="id" item-text="name" :error-messages="errors.project_id" :rules="rules.required"></v-autocomplete>
                          </v-flex>
                          <br>
                          <v-layout v-if="applyFeatures">
                            <v-flex md12>
                              <v-layout>
                                <h3 class="font-weight-black primary--text mb-0">{{ $t('general.concepts') }}</h3>
                                <v-flex class="text-right">
                                  <v-tooltip slot="append" bottom>
                                    <v-icon  @click="addConcepts" slot="activator" color="primary" :disabled="(!btnAddConcept) || editConcepts && editConceptsIndex > -1">add_circle</v-icon>
                                    <span>{{ $t('general.add') + " " + $t('general.concepts')}}</span>
                                  </v-tooltip>
                                </v-flex>
                              </v-layout>
                              <v-layout>
                                <v-data-table style="width: 100%; padding: 0px 5px;" :headers="conceptsHeaderUniversal" :items="editedItemReceiptUniversal.item_lines" :loading="loadTableConcepts" loading-text="Cargando contenido" :footer-props="{ 'items-per-page-options': [-1] }" hide-default-footer no-data-text="No hay datos que mostrar" :pagination.sync="pagination2" :rows-per-page-items="[10, 15, 25]" disable-pagination hide-actions>
                                  <template v-slot:items="props">
                                    <tr style="width: 100%; padding: 0px 5px;" :class="props.index % 2 === 0 ? 'grey-row' : 'white-row'">
                                      <td class="text-sm-left text-truncate" style="width: 40%; padding: 0px 5px;">
                                        <v-textarea @input="value => handleInputChange(value, props.item)" class="text-sm-center dynamic-textarea" rows="1" auto-grow outlined dense :hide-details="true" color="primary" v-model="props.item.line" :rules="rules.required && rules.max1000Characters" type="text" :disabled="editConcepts && editConceptsIndex !== -1"/>
                                      </td>
                                      <td style="width: 15%; padding: 0px 5px;">
                                        <v-text-field class="text-sm-center" @input="handleInputAmounts(props.item, editedItemReceiptUniversal.exchange)" outlined dense :hide-details="true" color="primary" v-model="props.item.amount" min="0" type="number" :rules="rules.required && rules.positiveNumber && rules.exchange" :disabled="editConcepts && editConceptsIndex !== -1"/>
                                      </td>
                                      <td style="width: 10%; padding: 0px 5px;" class="text-sm-center">
                                        <v-autocomplete class="text-sm-center" @input="handleInputAmounts(props.item, editedItemReceiptUniversal.exchange)" v-model="props.item.line_taxes[0].rate" item-text="name" item-value="id" dense hide-details :items="satIva" color="primary" :disabled="editConcepts && editConceptsIndex !== -1">
                                          <template slot="selection" slot-scope="data"> {{ data.item === 0 ? '0%' : data.item + '%' }} </template>
                                          <template #item="{ item }"> {{ item === 0 ? '0%' : item + '%' }} </template>
                                        </v-autocomplete>
                                      </td>
                                      <td style="width: 35%; padding: 0px 5px;" class="text-sm-center">
                                        <v-autocomplete class="text-sm-center" :label="$t('general.category')" v-model="props.item.gst_category_id" item-text="name" item-value="id" dense hide-details :rules="rules.required" :items="categoriesOrder" color="primary" :disabled="editConcepts && editConceptsIndex !== -1"/>
                                      </td>
                                    </tr>
                                    <tr style="width: 100%;" class="totals-row" :class="props.index % 2 === 0 ? 'grey-row' : 'white-row'">
                                      <td colspan="4" style="padding: 0; height: 10px">
                                        <div style="display: flex; justify-content: space-between; align-items: center;">
                                          <div style="flex: 1;"></div>
                                          <div style="flex: 0 0 auto; padding: 0 5px;">
                                            <b> {{ $t('general.total') }} : </b>
                                            <span>{{ props.item.line_taxes[0].amountText }}</span>
                                          </div>
                                          <div style="flex: 0 0 auto; padding: 0 5px;">
                                            <b> {{ $t('general.total') + ' ' + tagMoneda }} : </b>
                                            <span>{{ props.item.line_taxes[0].amountExchange }}</span>
                                          </div>
                                          <div style="flex: 0 0 auto; text-align: right; padding: 0 5px;">
                                            <v-tooltip bottom>
                                              <template v-slot:activator="{ on }">
                                                <v-btn small outlined icon color="error" v-on="on" @click="deleteConcept(props.item, props.index)" style="min-width: 24px; height: 24px; width: 24px;">
                                                  <v-icon small style="font-size: 16px;">delete</v-icon>
                                                </v-btn>
                                              </template>
                                              <span>{{ $t('general.delete') }}</span>
                                            </v-tooltip>
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  </template>
                                </v-data-table>
                              </v-layout>
                              <v-layout>
                                <v-flex >
                                  <span v-if="errorConcepts" class="red-text">{{ $t('general.required') }}</span>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                          <v-flex xs12>
                            <v-textarea
                              v-model="editedItemReceiptUniversal.description"
                              :label="$t('general.description')"
                              :error-messages="errors.description"
                              :rules="rules.required"
                            >
                            </v-textarea>
                          </v-flex>
                          <v-flex xs12 md5>
                            <v-text-field
                              v-model="editedItemReceiptUniversal.subtotal"
                              :label="$t('general.subtotal')"
                              :error-messages="errors.subtotal"
                              :disabled="editedItemReceiptUniversal.gst_receipt_types_id === 3"
                              :rules="rules.required && rules.decimal"
                              @keyup="getTotal(1)"
                            >
                              <v-tooltip slot="append" bottom>
                                <v-icon slot="activator" color="grey" dark
                                  >mdi-help-circle</v-icon
                                >
                                <span>{{ $t('expenses.amountMessage') }}</span>
                              </v-tooltip>
                            </v-text-field>
                            <p class="caption">
                              {{
                                amountMXN(
                                  editedItemReceiptUniversal.subtotal,
                                  editedItemReceiptUniversal.exchange
                                ) > 0.0
                                  ? '$' +
                                    amountMXN(
                                      editedItemReceiptUniversal.subtotal,
                                      editedItemReceiptUniversal.exchange
                                    ) +
                                    ' ' + tagMoneda
                                  : ''
                              }}
                            </p>
                          </v-flex>
                          <v-flex xs1 md2></v-flex>
                          <v-flex xs12 md5>
                            <v-text-field
                              v-model="editedItemReceiptUniversal.total"
                              :label="$t('general.total')"
                              :error-messages="errors.total"
                              :disabled="editedItemReceiptUniversal.gst_receipt_types_id === 3"
                              :rules="rules.required && rules.decimal"
                              @keyup="getTotal(2)"
                            >
                              <v-tooltip slot="append" bottom>
                                <v-icon slot="activator" color="grey" dark
                                  >mdi-help-circle</v-icon
                                >
                                <span>{{ $t('expenses.amountMessage') }}</span>
                              </v-tooltip>
                            </v-text-field>
                            <p class="caption">
                              {{
                                amountMXN(
                                  editedItemReceiptUniversal.total,
                                  editedItemReceiptUniversal.exchange
                                ) > 0.0
                                  ? '$' +
                                    amountMXN(
                                      editedItemReceiptUniversal.total,
                                      editedItemReceiptUniversal.exchange
                                    ) +
                                    ' ' + tagMoneda
                                  : ''
                              }}
                            </p>
                          </v-flex>
                          <v-flex xs12 md6>
                            <v-autocomplete
                              v-model="editedItemReceiptUniversal.sat_formaPago_id"
                              :label="$t('general.formaPago')"
                              :items="filteredSatFormaPago"
                              item-text="descripcion"
                              item-value="id"
                              :error-messages="errors.sat_formaPago_id"
                              :rules="rules.required"
                            >
                            </v-autocomplete>
                          </v-flex>
                          <v-flex xs12 md6>
                            <v-text-field
                              v-model="editedItemReceiptUniversal.folio"
                              :error-messages="errors.folio"
                              :label="
                                $t('general.folioRef') +
                                $t('general.optionalField')
                              "
                            >
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-textarea
                              v-model="editedItemReceiptUniversal.comment"
                              :label="
                                $t('general.comment') +
                                $t('general.optionalField')
                              "
                              :error-messages="errors.comment"
                            >
                            </v-textarea>
                          </v-flex>
                          <v-flex xs12 v-if="isAdding">
                            <vue-dropzone
                              ref="dropzoneUniversal"
                              id="dropzoneUniversal"
                              :options="dropzoneOptions"
                              v-on:vdropzone-file-added="fileAdded"
                              v-on:vdropzone-error="fileUploadError"
                              v-on:vdropzone-success="fileUploadUniversal">
                            >
                            </vue-dropzone>
                          </v-flex>
                          <v-flex xs12>
                          <v-container v-if="editedIndex > -1">
                          <label>{{ $t('general.image') }}:</label>
                          <v-btn
                          v-if="!isPDF(dataURL)"
                          depressed
                          color="primary"
                          block
                          @click="viewImg = !viewImg"
                        >
                          <v-icon left>{{
                            viewImg === false ? 'visibility' : 'visibility_off'
                          }}</v-icon>
                          {{
                            viewImg === false
                              ? $t('workflowValidation.showImage')
                              : $t('workflowValidation.hideImage')
                          }}
                        </v-btn>
                        <v-btn
                          block
                          v-if="isPDF(dataURL)"
                          @click="openPDF()"
                          color="primary"
                          depressed
                        >
                          <v-icon left>insert_drive_file</v-icon>
                          {{ $t('expenseItems.watchFile') }}
                        </v-btn>
                        <div v-if="viewImg === true">
                          <a v-if="!isPDF(dataURL)" @click="openPDF()">
                            <zoom-on-hover
                              :img-normal="dataURL"
                            ></zoom-on-hover>
                          </a>
                        </div>
                        <label>{{
                          $t('workflowValidation.changeImage')
                        }}</label>
                        </v-container>
                        <vue-dropzone
                        v-if="editedIndex > -1"
                          ref="dropzoneUniversal"
                          id="dropzoneUniversal"
                          :options="dropzoneOptions"
                          v-on:vdropzone-file-added="fileAdded"
                          v-on:vdropzone-error="fileUploadError"
                          v-on:vdropzone-success="fileUploadUniversal">
                        >
                        </vue-dropzone>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-form>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn round flat color="primary darken-1" @click="closeDialogExpenseUniversal()"> {{ $t('general.cancel') }} </v-btn>
                <v-btn v-if="!editedItemReceiptUniversal.id || editedItemReceiptUniversal.id === 0" round color="warning" flat @click="reset()"> {{ $t('general.clean') }} </v-btn>
                <v-btn round color="primary" :loading="loading" :disabled="loading" @click="submitExpenseUniversal()"> {{ editedItemReceiptUniversal.id && editedItemReceiptUniversal.id > 0 ? $t('general.save') : $t('general.charge') }} </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-flex>
      </v-layout>
      <v-data-table class="elevation-2" :headers="headers" :items="filteredExpenseItems" :loading="loadingItems" :pagination.sync="pagination">
        <template v-slot:headers="props">
          <tr>
            <th v-for="header in props.headers" :key="header.text"
              :class="[ 'column', header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
              :style="header.hidden ? 'display: none;' : ''"
              @click="changeSort(header.value)">
              <h2 class="font-weight-black primary--text mb-0">
                <v-icon small class="primary--text" v-if="header.sortable">arrow_upward</v-icon>{{ header.text }}
              </h2>
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <tr v-if="expense.has_multiprojects && props.item.isTitle && props.item.project_id" style="background-color: lightblue; height: 30px">
            <td colspan="8"><b>{{ $t('general.project') }} : {{ titleProject(props.item) }}</b></td>
          </tr>
          <tr style="border-bottom: none;" :class="{'custom-row-color': props.item.gst_receipt_types_id === 4}">
            <td class="text-sm-center">
              {{ props.item.gst_categories ? props.item.gst_categories.name: '- -' }}
              {{ props.item.receipt_type ? '(' + props.item.receipt_type.name + ')' : '- -' }}
            </td>
            <td class="text-sm-center d-none">{{ props.item.description }}</td>
            <td class="text-sm-center">
              <v-chip color="red" outline v-if="props.item.subtotal === null"> {{ props.item.subtotal | formatCurrency }} </v-chip>
              <span v-if="props.item.subtotal !== null">{{ props.item.subtotal | formatCurrency }}</span>
            </td>
            <td class="text-sm-center">{{ props.item.discount | formatCurrency }}</td>
            <td class="text-sm-center">
              <v-chip color="red" outline v-if="props.item.total === null">{{ props.item.total | formatCurrency }}</v-chip>
              <span v-if="props.item.total !== null">{{ props.item.total | formatCurrency }}</span>
            </td>
            <td class="text-sm-center">{{ props.item.exchange }}</td>
            <td class="text-sm-center">{{ props.item.total_mxn | formatCurrency }}</td>
            <td class="text-sm-center">{{ props.item.date }}</td>
            <td width="text-sm-center">
              <v-layout v-if="props.item.gst_receipt_types_id !== 4" row justify-center>
                <v-tooltip bottom v-if="props.item.required_attachment === true">
                  <template v-slot:activator="{ on }">
                    <v-btn small outline icon color="red" v-on="on" @click="attachFiles(props.item)">
                      <v-icon small>attach_file</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('expenses.attach') }} <br />
                    {{ $t('expenses.required_attachment') }} <br />
                    {{
                      props.item.file_attach.length +
                      ' ' +
                      $t('expenses.attachedFiles')
                    }}</span
                  >
                </v-tooltip>
                <v-tooltip
                bottom
                  v-if="props.item.required_attachment === false"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      small
                      outline
                      icon
                      :color="props.item.file_attach.length > 0 ? 'success' : 'info'"
                      v-on="on"
                      @click="attachFiles(props.item)"
                    >
                      <v-icon small>attach_file</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('expenses.attach') }} <br />{{ props.item.file_attach.length + ' ' + $t('expenses.attachedFiles') }}</span>
                </v-tooltip>
                <v-tooltip bottom v-if="props.item.receipt_type.id === 1">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      :disabled="props.item.subtotal === null"
                      v-on="on"
                      small
                      outline
                      icon
                      color="info"
                      @click="readXmlToHtml(props.item)"
                    >
                      <v-icon small>description</v-icon>
                    </v-btn>
                  </template>
                  <span>CFDI</span>
                </v-tooltip>
                <v-tooltip bottom v-if="props.item.receipt_type.id === 2 || props.item.receipt_type.id === 3">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      small
                      outline
                      icon
                      color="info"
                      v-on="on"
                      @click="editItem(props.item, props.item.receipt_type.id)"
                    >
                      <v-icon small>edit</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('general.edit') }}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      :disabled="props.item.subtotal === null"
                      small
                      outline
                      icon
                      color="error"
                      v-on="on"
                      @click="deleteItem(props.item)"
                    >
                      <v-icon small>delete</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('general.delete') }}</span>
                </v-tooltip>
                <v-tooltip  bottom v-if="!isVoucherBlue && showTip(props.item)">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      :disabled="props.item.subtotal === null"
                      small
                      outline
                      icon
                      color="warning"
                      v-on="on"
                      @click="addTip(props.item)"
                    >
                      <v-icon small>fa fa-donate</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('expenses.addWatchTip') }}</span>
                </v-tooltip>
              </v-layout>
            </td>
          </tr>
          <tr :class="{'custom-row-color': props.item.gst_receipt_types_id === 4}">
            <td colspan="5">{{ props.item.description ? props.item.description : '- -' }}</td>
            <td colspan="2" class="text-sm-left" v-if="props.item.tip && props.item.tip.amount">
              {{ $t('general.amount') }} + {{ $t('expenses.tip') }} = {{ currencyFormat(amountAndTip(props.item)) }}
            </td>
            <td colspan="3" class="text-sm-left" v-else></td>
          </tr>
        </template>
        <template v-slot:footer>
          <tr>
            <td class="text-xs-center">
              <strong>{{ $t('general.totalExpenses') }}</strong>
            </td>
            <td class="text-xs-center">
              <strong>{{ currencyFormat(sumaSubtotal) }}</strong>
            </td>
            <td class="text-xs-center">
              <strong>{{ currencyFormat(sumaDescuento) }}</strong>
            </td>
            <td class="text-xs-center">
              <strong>{{ currencyFormat(sumaTotal) }}</strong>
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-layout class="">
        <v-flex>
          <v-btn :disabled="!validationByStatus"  class="ml-auto" @click="showWorkflowDialog(editedItem)"  style="border-radius: 25px;" color="primary">
            <v-icon color="white" class="mr-1">play_arrow</v-icon>
            <span>{{ this.$t('expenses.sendValidation') }}</span>
          </v-btn>
        </v-flex>
        <v-flex></v-flex>
        <v-flex v-if="!validationByStatus">
          <v-alert :value="isVoucherBlue" type="warning" class="alertValidate">
              {{ $t('expenses.blueVoucher.amountNotComplyRules') }}
          </v-alert>
          <v-alert :value="isTravelExpense" type="warning" class="alertValidate">
              {{ $t('expenses.travelExpense.amountNotComplyRules') }}
          </v-alert>
        </v-flex>
      </v-layout>
      <v-dialog persistent v-model="workflowDialog" max-width="500px">
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">
              {{ $t('expenses.sendValidation') }}
            </h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <p>{{ $t('expenses.sendValidationMessage') }}</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary darken-1"
              round
              flat
              @click="closeWorkflowDialog"
            >
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn
              color="primary"
              round
              depressed
              :loading="loading"
              :disabled="loading"
              @click="doStartWorkflow"
            >
              {{ $t('expenses.start') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="workflowDialogValidate" max-width="500px">
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">
              {{ $t('expenses.blueVoucher.errorWorkFlow') }}
            </h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <p>{{ $t('expenses.blueVoucher.errorFile') }}</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary darken-1"
              round
              flat
              @click="workflowDialogValidate=false"
            >
              {{ $t('general.close') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="removeDialog" scrollable max-width="500px">
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black error--text mb-0">
              {{ $t('expenseItems.delete') }}
            </h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <p>{{ $t('general.deleteElementQuestion') }}</p>
            <p class="font-weight-black">
              <span class="error--text"
                >{{ $t('expenseItems.description') }}: </span
              >{{ editedItem.description }}
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error darken-1"
              round
              flat
              @click="removeDialog = false"
            >
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn color="error" round depressed @click="removeItem">
              {{ $t('general.delete') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="deleteConceptConfirm" scrollable max-width="500px">
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black error--text mb-0">
              {{ $t('expenseItems.deleteConcepts') }}
            </h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <p>{{ $t('general.deleteElementQuestion') }}</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error darken-1"
              round
              flat
              @click="defaultDeleteConcept"
            >
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn color="error" round depressed @click="deleteConceptConfirmed()">
              {{ $t('general.delete') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="cfdiDialog" scrollable max-width="900px">
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">
              {{ $t('expenseItems.fiscal') }}
            </h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <iframe
              name="cfdi"
              :srcdoc="cfdiHtml"
              style="width: 845px; height: 1200px; border: 0"
            ></iframe>
            <v-form lazy-validation v-if="editedItem.gst_categories" ref="formCfdiDialog">
              <v-flex>
                <v-autocomplete
                  v-model="editedItem.gst_categories_id"
                  :label="$t('general.category')"
                  :items="categoriesOrder"
                  item-text="name"
                  item-value="id"
                  :error-messages="errors.gst_categories_id"
                  :rules="rules.required"
                >
                  <template slot="selection" slot-scope="data">
                    {{ data.item.name }}
                  </template>
                  <template slot="item" slot-scope="data">
                    {{ data.item.name }}
                  </template>
                </v-autocomplete>
                <v-text-field
                  :label="$t('general.comment')"
                  v-model="editedItem.comment"
                  :error-messages="errors.comment"
                />
              </v-flex>
              <v-form
                v-if="editedItemTip.created_at !== ''"
                ref="tipForm"
                lazy-validation
              >
                <h2 class="font-weight-black primary--text mb-0">
                  {{ $t('expenses.tip') }}
                </h2>
                <v-container>
                  <v-layout row wrap>
                    <v-flex xs12 md6>
                      <v-text-field
                        v-model="editedItemTip.amount"
                        :error-messages="errors.amount"
                        :rules="rules.required"
                        :label="$t('general.amount')"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 layout v-if="dataURL">
                      <v-flex xs12>
                        <label>{{ $t('expenses.file') }}:</label>
                        <a v-if="!isPDF(dataURL)" @click="openPDF()">
                          <zoom-on-hover :img-normal="dataURL"></zoom-on-hover>
                        </a>
                        <v-btn
                          block
                          v-if="isPDF(dataURL)"
                          @click="openPDF()"
                          color="primary"
                          depressed
                        >
                          <v-icon left>insert_drive_file</v-icon>
                          {{ $t('expenseItems.watchFile') }}
                        </v-btn>
                        <iframe
                          v-if="isPDF(dataURL)"
                          :src="dataURL"
                          frameborder="0"
                          width="100%"
                          height="400px"
                        ></iframe>
                      </v-flex>
                    </v-flex>
                    <v-flex xs12>
                      <vue-dropzone
                        v-if="editedItemTip.created_at === ''"
                        ref="dropzone"
                        id="dropzone"
                        :options="dropzoneOptions"
                        v-on:vdropzone-file-added="fileAdded"
                        v-on:vdropzone-error="fileUploadError"
                        v-on:vdropzone-success="fileUploadTip"
                      >
                      </vue-dropzone>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error darken-1" round flat @click="closeCfdiDialog">
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn
              :disabled="!cfdiHtml"
              round
              flat
              color="primary"
              @click="sendToPrint()"
            >
              <v-icon left>print</v-icon> {{ $t('general.print') }}
            </v-btn>
            <v-btn
              :disabled="!cfdiHtml || loading"
              :loading="loading"
              round
              depressed
              color="primary"
              @click="submit()"
            >
              {{ $t('general.save') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogTip" max-width="600px" scrollable persistent>
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">
              {{ formTitleTip }}
            </h2>
          </v-toolbar>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-form ref="tipForm" lazy-validation>
                  <v-container>
                    <v-layout row wrap>
                      <v-flex xs12 md6>
                        <v-text-field
                          v-model="editedItemTip.amount"
                          :error-messages="errors.amount"
                          :rules="rules.required"
                          :label="$t('general.amount')"
                        >
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 layout v-if="dataURL">
                        <v-flex xs12>
                          <label>{{ $t('expenses.file') }}:</label>
                          <a v-if="!isPDF(dataURL)" @click="openPDF()">
                            <zoom-on-hover
                              :img-normal="dataURL"
                            ></zoom-on-hover>
                          </a>
                          <v-btn
                            block
                            v-if="isPDF(dataURL)"
                            @click="openPDF()"
                            color="primary"
                            depressed
                          >
                            <v-icon left>insert_drive_file</v-icon>
                            {{ $t('expenseItems.watchFile') }}
                          </v-btn>
                          <iframe
                            v-if="isPDF(dataURL)"
                            :src="dataURL"
                            frameborder="0"
                            width="100%"
                            height="400px"
                          ></iframe>
                        </v-flex>
                      </v-flex>
                      <v-flex xs12>
                        <vue-dropzone
                          v-if="editedItemTip.created_at === ''"
                          ref="dropzone"
                          id="dropzone"
                          :options="dropzoneOptions"
                          v-on:vdropzone-file-added="fileAdded"
                          v-on:vdropzone-error="fileUploadError"
                          v-on:vdropzone-success="fileUploadTip"
                        >
                        </vue-dropzone>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              v-if="editedItemTip.created_at !== ''"
              round
              flat
              color="primary darken-1"
              @click="closeDialogTip()"
            >
              {{ $t('general.close') }}
            </v-btn>
            <v-btn
              v-if="editedItemTip.created_at === ''"
              round
              flat
              color="primary darken-1"
              @click="closeDialogTip()"
            >
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn
              v-if="editedItemTip.created_at === ''"
              round
              color="primary"
              :loading="loading"
              :disabled="loading"
              @click="submitTip()"
            >
              {{ $t('general.add') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
/* eslint-disable */
import vue2Dropzone from 'vue2-dropzone'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faDonate } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faDonate)
export default {
  name: 'expenseItemComponent',
  components: {
    vueDropzone: vue2Dropzone,
    'font-awesome-icon': FontAwesomeIcon,
  },
  data() {
    return {
      itemDeleteConcept:{},
      deleteConceptConfirm:false,
      workflowDialog: false,
      workflowDialogValidate: false,
      viewRecipt: false,
      expandMenu: true,
      errorConcepts: false,
      btnAddConcept: true,
      editConceptsIndex: -1,
      categories: [],
      editConcepts: true,
      pagination2: {
        descending: false,
        page: 1,
        rowsPerPage: 15,
        totalItems: 0,
      },
      loadTableConcepts: false,
      dialogUniversalExpense: false,
      viewCfdi: false,
      viewExpenseUniversal: false,
      tagMoneda: '',
      commentE: true,
      etiqMoneda: '',
      currencySetting: {},
      countrySetting: {},
      commentSetting: {},
      settings: {},
      loadingCategories: true,
      categoriesPending: [],
      notifications: false,
      sound: false,
      video: false,
      invites: false,
      search: null,
      items: [],
      pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        totalItems: 0,
      },
      errors: {},
      dialog: false,
      dialogTip: false,
      dialogXML: false,
      loading: false,
      loadingFile: false,
      loadingItems: true,
      uploadedXML: [],
      uploadIndex: -1,
      removeDialog: false,
      viewImg: false,
      dataURL: null,
      expense: {},
      expenseItems: [],
      filteredExpenseItems: [],
      editedIndex: -1,
      editedIndexTip: -1,
      editedItem: {
        emisor: '',
        gst_expenses_id: null,
        gst_receipt_types_id: 2,
        date: null,
        item_lines: [],
        conceptos: [],
        gst_categories_id: null,
        categoryName: '',
        is_refund: false,
        description: '',
        exchange: 1,
        subtotal: '',
        total: '',
        country: {
          id: '',
          descripcion: '',
        },
        currency: {
          id: '',
          descripcion: '',
        },
        folio: '',
        comment: '',
        fileId: null,
        discount: null,
        sat_forma_pago: {
          descripcion: '',
        },
        sat_metodo_pago: {
          descripcion: '',
        },
        hasTip: false,
        gst_categories: {
          id: null,
          name: ''
        }
      },
      defaultItem: {
        emisor: '',
        gst_expenses_id: null,
        gst_receipt_types_id: 2,
        date: null,
        item_lines: [],
        conceptos: [],
        gst_categories_id: null,
        categoryName: '',
        is_refund: false,
        description: '',
        exchange: 1,
        subtotal: '',
        total: '',
        country: {
          id: '',
          descripcion: '',
        },
        currency: {
          id: '',
          descripcion: '',
        },
        sat_forma_pago: {
          descripcion: '',
        },
        sat_metodo_pago: {
          descripcion: '',
        },
        folio: '',
        comment: '',
        fileId: null,
        discount: null,
        hasTip: false,
        amountTip: null,
        fileIdTip: null,
        gst_categories: {
          id: null,
          name: ''
        }
      },
      editedItemReceiptUniversal: {
        id: 0,
        emisor: '',
        gst_expenses_id: null,
        gst_receipt_types_id: 3,
        date: null,
        gst_categories_id: null,
        supplier: '',
        iva:0,
        categoryName: '',
        is_refund: false,
        description: '',
        exchange: 1,
        subtotal: 0,
        total: 0,
        vendorSelect:'',
        vendor:{
          id: 0,
          name: '',
          tax_id: '',
          is_foreign: true,
          tax_id_validation_numbers:''
        },
        country: {
          id: 174,
          descripcion: '',
        },
        currency: {
          id: 149,
          descripcion: '',
        },
        foreign_tax:{
          percent: 0,
          tax: 'IVA',
          amount: 0,
        },
        item_lines:[],
        folio: '',
        comment: '',
        fileId: null,
        discount: null,
        sat_forma_pago: {
          descripcion: '',
        },
        sat_metodo_pago: {
          descripcion: '',
        },
        hasTip: false,
        gst_categories: {
          id: null,
          name: ''
        }
      },
      editedItemReceiptUniversalDefault: {
        id: 0,
        emisor: '',
        gst_expenses_id: null,
        gst_receipt_types_id: 3,
        date: null,
        gst_categories_id: null,
        supplier: '',
        iva:0,
        categoryName: '',
        is_refund: false,
        description: '',
        exchange: 1,
        subtotal: 0,
        total: 0,
        vendorSelect:'',
        vendor:{
          id: 0,
          name: '',
          tax_id: '',
          is_foreign: true,
          tax_id_validation_numbers:''
        },
        country: {
          id: 174,
          descripcion: '',
        },
        currency: {
          id: 149,
          descripcion: '',
        },
        foreign_tax:{
          percent: 0,
          tax: 'IVA',
          amount: 0,
        },
        item_lines:[],
        folio: '',
        comment: '',
        fileId: null,
        discount: null,
        sat_forma_pago: {
          descripcion: '',
        },
        sat_metodo_pago: {
          descripcion: '',
        },
        hasTip: false,
        gst_categories: {
          id: null,
          name: ''
        }
      },
      editedItemTip: {
        id: null,
        amount: null,
        fileId: null,
        created_at: '',
      },
      defaultItemTip: {
        id: null,
        amount: null,
        fileId: null,
        created_at: '',
      },
      datemenu: false,
      dateMenuUniversal: false,
      fileName: '',
      fileUrl: '',
      file: '',
      categories: [],
      categoriesRelated: [],
      satFormaPago: [
        { id: 1, descripcion: 'Efectivo' },
        { id: 3, descripcion: 'Transferencia electrónica de fondos' },
        { id: 4, descripcion: 'Tarjeta de crédito' },
        { id: 18, descripcion: 'Tarjeta de débito' },
        { id: 19, descripcion: 'Tarjeta de servicios' },
        { id: 22, descripcion: 'Por definir' },
        { id: 23, descripcion: 'Vales de despensa' },
      ],
      satMetodoPago: [],
      satMoneda: [],
      satIva:[0, 7],
      satPais: [],
      error: false,
      errorMessage: '',
      // no fiscal
      dropzoneOptions: {
        url: process.env.HOST + 'api/File',
        dictDefaultMessage: this.$t('dropzone.default', {
          size: '5',
          unit: 'MB',
        }),
        dictResponseError: this.$t('dropzone.responseError'),
        dictFileTooBig: this.$t('dropzone.fileTooBig'),
        dictInvalidFileType: this.$t('dropzone.invalidFileType'),
        dictRemoveFile: this.$t('dropzone.removeFile'),
        dictRemoveFileConfirmation: this.$t('dropzone.removeFileConfirmation'),
        dictMaxFilesExceeded: this.$t('dropzone.maxFilesExceeded'),
        addRemoveLinks: true,
        thumbnailWidth: 150,
        maxFilesize: 5,
        resizeWidth: 1080,
        resizeHeight: 1080,
        resizeMethod: 'contain',
        resizeQuality: 0.8,
        paramName: 'path',
        acceptedFiles: '.jpeg,.jpg,.png,.pdf',
        maxFiles: 1,
        headers: {
          Authorization: 'Bearer ' + this.$store.state.userState.access_token,
        },
        params: {
          user_id: this.$store.state.userLogged.id,
          dirname: 'IMG_EXPENSES',
        },
      },
      // fiscal
      dropzoneOptionsXML: {
        url: process.env.HOST + 'api/File',
        dictDefaultMessage: this.$t('dropzone.textFileXml', {
          size: '500',
          unit: 'KB',
        }),
        // dictResponseError: this.$t('dropzone.responseError'),
        dictFileTooBig: this.$t('dropzone.fileTooBig'),
        dictInvalidFileType: this.$t('dropzone.invalidFileType'),
        dictRemoveFile: this.$t('dropzone.removeFile'),
        dictRemoveFileConfirmation: this.$t('dropzone.removeFileConfirmation'),
        dictMaxFilesExceeded: this.$t('dropzone.maxFilesExceeded'),
        addRemoveLinks: true,
        thumbnailWidth: 150,
        maxFilesize: 0.5,
        paramName: 'path',
        dictResponseError: this.errorFileUpload,
        acceptedFiles: '.xml',
        // maxFiles: 1,
        headers: {
          Authorization: 'Bearer ' + this.$store.state.userState.access_token,
        },
        params: {
          user_id: this.$store.state.userLogged.id,
          files_type_id: 7,
          dirname: 'XML_EXPENSES',
        },
      },
      selectXml: null,
      readXml: null,
      nextXml: false,
      cfdiHtml: null,
      cfdiDialog: false,
      date: new Date().toISOString().substr(0, 10),
      sumaSubtotal: 0,
      sumaDescuento: 0,
      sumaTotal: 0,
      loadingDownload: false,
      loadExpense: false,
      currencySeleted: 'MXN',
      typeChange: '',
      vendors: [],
      disabledCheckIsNational: false,
      keywords: [],
      timer: null,
      keywordsFilter: {},
      toCheck: 0,
      checked: 0,
      expenseAdvance: 0,
      typeExpenseInput: this.$t('general.advance'),
      expenseToCheckedInput: this.$t('general.checked'),
      expenseCheckedInput: this.$t('general.toCheck'),
      isVisibleInputsAmount: false,
      isVisibleInputsAmountAmex: false,
      isVoucherBlue: false,
      isTravelExpense: false,
      idMultiProjects: []
    }
  },
  created() {
    this.get()
  },
  computed: {
    hasMultiProjects(){
      if(this.$store.state.userLogged && this.$store.state.userLogged.company[0].features.find(x => x.name === 'MULTIPROJECTS')) return true
      
      return false
    },
    applyFeatures(){
      if(this.$store.state.userLogged.company === undefined){
        return false
      }

      if(this.$store.state.userLogged.company[0].features.find(x => x.name === 'EXPENSE_LINES')){
        return true
      }

      return false
    },
    conceptsHeaderUniversal() {
      return [
        {
          text: this.$t('general.description'),
          align: 'center',
          value: 'description',
          sortable: false
        },
        {
          text: this.$t('general.amount'),
          value: 'amount',
          sortable: false
        },
        {
          text: this.$t('general.iva'),
          align: 'center',
          value: 'amount',
          sortable: false
        },
        {
          text: this.$t('general.category'),
          align: 'center',
          value: 'category',
          sortable: false
        },
      ]
    },
    filteredSatFormaPago() {
      const desiredOptions = [
        'Efectivo',
        'Transferencia electrónica de fondos',
        'Tarjeta de crédito',
        'Tarjeta de débito',
        'Tarjeta de servicios',
      ]
      const filteredOptions = this.satFormaPago.filter(option => {
        if (option.descripcion === 'Vales de despensa' && option.id === 23) {
          return true
        }
        return desiredOptions.includes(option.descripcion)
      })
      const porDefinirOption = this.satFormaPago.find(option => option.descripcion === 'Por definir')
      if (porDefinirOption) {
        filteredOptions.push(porDefinirOption)
      }
      if (porDefinirOption) {
        porDefinirOption.descripcion = 'Otros'
      }
      return this.removeDuplicates(filteredOptions, 'descripcion')
    },
    selectedFormattedItem() {
      return this.editedItemReceiptUniversalDefault.iva ? `${this.editedItemReceiptUniversalDefault.iva}%` : "";
    },
    getTotalPending() {
      let totalPending = 0
      let counterRelated = 0
      if (this.filteredExpenseItems.length > 0) {
        this.filteredExpenseItems.forEach((expense) => {
          if (
            this.categoriesRelated.find(
              (x) => x.category_id === expense.category_id
            ) !== -1
          ) {
            counterRelated++
          }
        })
      }
      totalPending = this.categoriesRelated.length - counterRelated
      return totalPending
    },
    setMXN() {
      let item = this.editedItem
      if (item.currency !== undefined && item.currency.id === 100) {
        item.exchange = 1
        return true
      } else {
        return false
      }
    },
    heading() {
      return this.$t('expenseItems.title')
    },
    subheading() {
      return ''
    },
    icon() {
      return 'fas fa-file-invoice-dollar fa-fw icon-color'
    },
    errorFileUpload() {
      return this.errorMessage
    },
    headers() {
      return [
        {
          text: this.$t('general.category'),
          align: 'center',
          value: 'gst_categories.name',
          sortable: false,
        },
        {
          text: this.$t('general.description'),
          align: 'center',
          value: 'description',
          sortable: false,
          hidden: true,
        },
        {
          text: this.$t('general.subtotal'),
          align: 'center',
          value: 'subtotal',
          sortable: false,
        },
        {
          text: this.$t('general.discount'),
          align: 'center',
          value: 'discount',
          sortable: false,
        },
        {
          text: this.$t('general.total'),
          align: 'center',
          value: 'total',
          sortable: false,
        },
        {
          text: this.$t('expenseItems.exchangeRate'),
          align: 'center',
          value: 'exchange',
          sortable: false,
        },
        {
          text: `${this.$t('general.total')} ${this.etiqMoneda}`,
          align: 'center',
          value: 'total',
          sortable: false,
        },
        {
          text: this.$t('general.date'),
          align: 'center',
          value: 'date',
          sortable: false,
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
          sortable: false,
        },
      ]
    },
    conceptsHeader() {
      return [
        {
          text: this.$t('general.description'),
          align: 'center',
          value: 'description',
          sortable: false,
          fixed: true,
        },
        {
          text: this.$t('general.amount'),
          align: 'center',
          value: 'import',
          sortable: false,
          fixed: true,
        },
        {
          text: this.$t('general.category'),
          align: 'center',
          value: 'category',
          sortable: false,
          fixed: true,
        },
      ]
    },
    rules() {
      return this.$validationRules()
    },
    isAdding() {
    return this.editedIndex === -1;
    },
    formTitle() {
      if (this.editedIndex > -1) {
        return this.$t('expenseItems.name')
      } else {
        return this.$t('general.receipt')
      }
    },
    formTitleTip() {
      if (this.editedItemTip.created_at !== '') {
        return this.$t('expenses.tip')
      } else {
        return this.$t('expenses.addTip')
      }
    },
    expense_id() {
      return this.$route.params.id
    },
    dataArrayFilter() {
      return this.$searchCountry()
    },
    submitXMLButton() {
      return this.uploadIndex + 1 < this.uploadedXML.length ? this.$t('general.next') : this.$t('general.charge')
    },
    validationByStatus() {
      if(this.validateObjNull(this.expense)) return false

      if (this.expense.is_blue_voucher && this.expense.blue_voucher_validation && (this.expense.blue_voucher_validation.status === 'CANT_SEND_OVER' || this.expense.blue_voucher_validation.status === 'CANT_SEND_UNDER')) return false
      
      if (this.expense.is_imported_expense && this.expense.imported_expenses_validation && (this.expense.imported_expenses_validation.status === 'CANT_SEND_OVER' || this.expense.imported_expenses_validation.status === 'CANT_SEND_UNDER')) return false

      if(this.expense) return true
    },
    viewBtnExpenseAdd() {
      if(this.validateObjNull(this.expense)) return false

      if (this.expense.is_blue_voucher && this.expense.blue_voucher_validation && (this.expense.blue_voucher_validation.status === 'CANT_SEND_OVER' || this.expense.blue_voucher_validation.status === 'SEND_WITH_ADJUSTMENT')) return false
      
      if (this.expense.is_imported_expense && this.expense.imported_expenses_validation && (this.expense.imported_expenses_validation.status === 'CANT_SEND_OVER' || this.expense.imported_expenses_validation.status === 'SEND_WITH_ADJUSTMENT')) return false

      if(this.expense) return true
    },
    categoriesOrder () {
      if(this.categories.length > 0) return this.categories.sort((a, b) => a.name.localeCompare(b.name, 'es', { sensitivity: 'base' }));
      return []
    },
  },
  watch: {
   'editedItem'() {
      if(!this.conceptos) return

      this.editedItem.conceptos = this.conceptos
      this.editedItem.conceptos.forEach((x)=>{
    
      if(this.existFeature('DEFAULT_CATEGORY_REFUND') && parseFloat(this.expense.advance) <= 0 && this.expense.petty_cash_type === 0) return x.gst_category_id = parseInt(this.$store.state.userLogged.company[0].features.find(x => x.name === 'DEFAULT_CATEGORY_REFUND').pivot.param1)

      if(this.existFeature('DEFAULT_CATEGORY_TRAVEL_EXPENSE') && this.expense.is_imported_expense === 1) return x.gst_category_id = parseInt(this.$store.state.userLogged.company[0].features.find(x => x.name === 'DEFAULT_CATEGORY_TRAVEL_EXPENSE').pivot.param1)

      let categorias = this.getCategoryAutomatic(x.Descripcion)
      x.gst_category_id = categorias
    })
    },
    keywords(){
      if(this.keywords.length > 0){
        this.keywordsFilter = this.keywords.map(item => ({
          keyword: item.keyword,
          gst_categories_id: item.gst_categories_id
        }))
      }
    },  
    'editedItem.total'() {
     this.tagMoneda = this.currencySetting.value.c_Moneda;
    },
    // 'editedItemReceiptUniversal.foreign_tax.percent'() {
    //  if(this.viewExpenseUniversal && this.editedItemReceiptUniversal.gst_receipt_types_id === 3) this.getTotal(3)
    // },
    'editedItem.subtotal'() {
     this.tagMoneda = this.currencySetting.value.c_Moneda;
    },
    'editedItemReceiptUniversal.total'() {
     this.tagMoneda = this.currencySetting.value.c_Moneda;
    },
    'editedItemReceiptUniversal.subtotal'() {
     this.tagMoneda = this.currencySetting.value.c_Moneda;
    },
    settings(){
      this.filterCurrency()
      this.filterCountry()
      this.filterComment()
      this.viewButtons()
    },
    expense() {
      if (this.expense.start_date !== undefined) {
        this.editedItemReceiptUniversal.date = this.expense.start_date
        if (this.expense.gst_travel_expenses_request_id !== null) {
          this.getCategoriesRelated(this.expense.gst_travel_expenses_request_id)
        }
      }

      this.calculateAmount()

      this.isVoucherBlue = this.expense.is_blue_voucher === 1
      this.isTravelExpense = this.expense.is_imported_expense === 1
    },
    keywords(){
      if(this.keywords.length > 0){
        this.keywordsFilter = this.keywords.map(item => ({
          keyword: item.keyword,
          gst_categories_id: item.gst_categories_id
        }))
      }
    },
    '$route.params.id': function (id) {
      this.get()
    },
    '$store.state.userLogged'() {
      if(this.$store.state.userLogged){
        this.$store.dispatch('keywords/get', { event: {context: this} })
      }
      this.dropzoneOptions.params.user_id = this.$store.state.userLogged.id
      this.dropzoneOptionsXML.params.user_id = this.$store.state.userLogged.id
      this.viewButtons()
    },
    removeDialog(val) {
      val || this.closeRemove()
    },
    search(val) {
      this.querySelection(val)
      this.dataArrayFilter.search(this.editedItem.country.id, val)
    },
    dialogXML() {
      if (this.dialogXML === true) {
        this.selectXml = true
      }
    },
  },
  methods: {
    titleProject(item){
      return item.gst_expenses.multiprojects.find(x => x.id === item.project_id).name
    },
    addTitleElements(arr) {
      const result = [];
      let currentProjectId = null;

      arr.forEach((item) => {
          if (item.project_id !== currentProjectId) {
              currentProjectId = item.project_id;

              // Crear el nuevo objeto con isTitle en true
              const titleObject = {
                  ...item,
                  isTitle: true,
              };

              result.push(titleObject);
          }

          // Añadir el elemento original con isTitle en false
          result.push({
              ...item,
              isTitle: false,
          });
      });

      return result;
    },
    validateObjNull(obj){
      if (!obj || Object.keys(obj).length === 0) return true;
      return false
    },
    calculateAmount(){
      let amountItemExpense = 0;

      if (this.expense.gst_expenses_items.length > 0) {
        amountItemExpense = this.expense.gst_expenses_items.reduce((accumulator, value) => {
          return accumulator + parseFloat(value.total);
        }, 0);
      }
      
      this.checked = amountItemExpense.toFixed(2)
      // BLUE VOUCHER UPDATE
      if(this.expense.is_blue_voucher === 1) {
        this.expenseAdvance = this.expense.voucher_amount
        this.toCheck = this.advance - this.checked
        this.typeExpenseInput = this.$t('general.voucherAmount')
        this.expenseToCheckedInput = this.$t('general.checked')
        this.expenseCheckedInput = this.$t('general.remainingAmount')
        let amountVoucherBlue = (this.expenseAdvance - this.checked).toFixed(2)
        this.toCheck = amountVoucherBlue < 0 ? 0.00 : amountVoucherBlue
        this.isVisibleInputsAmount = true
        this.isVisibleInputsAmountAmex = this.expense.petty_cash_type === 1
        if(this.expense.user.small_box){
          this.expenseIsAmex = this.expense.petty_cash_type === 2 ? this.$t('pettyCash.amexCard') : this.$t('pettyCash.pettyCash')
          this.expenseIsAmexAmount = this.expense.petty_cash_type === 2 ? this.expense.user.small_box.find(x => x.type === 2).amount : this.expense.user.small_box.find(x => x.type === 1).amount
        }
        return
      }

      // if (this.expense.advance === '0.00' && this.expense.petty_cash_type === 0 && this.expense.is_blue_voucher === 0) {
      //   //REFOUND REEMBOLSO
      // } 

      if (this.expense.petty_cash_type === 1) {
        //PETTY CASH / CAJA CHICA
        this.expenseAdvance = this.expense.user.small_box.find(x => x.type === 1).amount
        this.typeExpenseInput = this.$t('general.amountPettyCash')
        this.expenseToCheckedInput = this.$t('general.checked')
        this.expenseCheckedInput =  this.$t('general.availableBox')
        this.toCheck = (this.expenseAdvance - this.checked).toFixed(2)
        this.isVisibleInputsAmount = true
        return
      }

      if (this.expense.advance !== '0.00') {
        //ADVANCE / ANTICIPO
        this.expenseAdvance = this.expense.advance
        this.typeExpenseInput = this.$t('general.advance')
        this.expenseToCheckedInput = this.$t('general.checked')
        this.expenseCheckedInput = this.$t('general.toCheck')
        this.toCheck = (this.expenseAdvance - this.checked).toFixed(2)
        this.isVisibleInputsAmount = true
        return
      } 
    },
    seletectingCurrency(selectedItem){
      if(selectedItem === undefined){
        this.currencySeleted = ''
        this.typeChange = ''
        return
      }

      this.currencySeleted = selectedItem.c_Moneda
      this.typeChange = this.currencySetting.value.c_Moneda === selectedItem.c_Moneda ? '' : '(' + selectedItem.c_Moneda + ' a ' + this.currencySetting.value.c_Moneda + ')'
    },
    showWorkflowDialog(item) {
      if(this.expense.is_blue_voucher === 1 && !this.filteredExpenseItems.some(item => item.file_attach.length > 0)) return this.workflowDialogValidate = true
      this.workflowDialog = true
      this.editedItem = Object.assign({}, item)
    },
    closeWorkflowDialog() {
      this.workflowDialog = false
      this.editedItem = Object.assign({}, this.defaultItem)
      this.$refs.form.resetValidation()
      this.loading = false
    },
    doStartWorkflow() {
      this.loading = true
      this.startWorkflow()
      this.$router.go(-1)
    },
    startWorkflow() {
      let item = {id:this.$route.params.id}
      this.$emit('startWorkflow', {
        context: this,
        item: item,
      })
    },
    addConcepts() {
        const item = {}
        item.gst_category_id = this.editedItemReceiptUniversal.gst_categories_id
        item.line = ""
        item.amount = 0
        item.line_taxes = [{
          is_mx: false,
          type: "traslado",
          amount: 0,
          amountText:0,
          amountExchange:0,
          rate: 0,
          tax_name: "iva"
        }];

      this.editedItemReceiptUniversal.item_lines.push(item)
    },
    removeDuplicates(array, key) {
      const seen = new Set()
      return array.filter(item => {
        const value = item[key]
        if (!seen.has(value)) {
          seen.add(value)
          return true
        }
        return false
      })
     },
    viewButtons(){
      if(this.settings && this.$store.state.userLogged){
        let countrySetting =  this.settings.find(x => x.setting_type.name == "st.country" && x.company_id == this.$store.state.userLogged.company[0].id)
        let cPais = countrySetting.value.c_Pais
        this.viewCfdi = cPais == 'MEX'
        this.viewRecipt = cPais == 'MEX'
        this.viewExpenseUniversal = cPais !== 'MEX'
      }
    },
    filterCurrency() {
    const foundCurrencySetting = this.settings.find(x => x.setting_type.name == "st.currency" && x.company_id == this.$store.state.userLogged.company[0].id)
    this.currencySetting = foundCurrencySetting ? foundCurrencySetting : { value: { c_Moneda: 'MXN' } }
    this.etiqMoneda = this.currencySetting.value.c_Moneda
    this.editedItem.currency = this.currencySetting.value
    this.defaultItem.currency = this.currencySetting.value
    },
    filterCountry () {
      this.countrySetting = this.settings.find(x => x.setting_type.name == "st.country" && x.company_id == this.$store.state.userLogged.company[0].id)
      this.editedItem.country = this.countrySetting.value
      this.defaultItem.country = this.countrySetting.value
    },
    filterComment() {
      this.commentSetting = this.settings.find(x => x.setting_type.name === "st.expenseComment" && x.company_id === this.$store.state.userLogged.company[0].id)
      if (!this.commentSetting || !this.commentSetting.value.fiscal) {
        this.commentSetting = undefined
        this.commentE = false
      } else {
        this.commentE = this.commentSetting.value.fiscal.comment_required;
      }
    },
    amountAndTip(item) {
      let amount = 0
      let tip = 0
      const totalMxn = item.total_mxn
      if (totalMxn && totalMxn > 0) {
        amount = parseFloat(totalMxn)
      }
      const amountTip = item.tip && item.tip.amount ? item.tip.amount : 0
      if (amountTip > 0) {
        tip = parseFloat(amountTip)
      }
      const total = amount + tip
      return total
    },
    disableCategories() {
      this.categoriesPending = []
      if (this.categories.length > 0) {
        this.categories.forEach((category) => {
          if (
            this.getPendingByCategory(category.id) === 0 &&
            this.getTotalPending > 0
          ) {
            category.disabled = true
          } else {
            this.categoriesPending.push(category)
            category.disabled = false
          }
        })
      }
      this.loadExpense = true
    },
    getPendingByCategory(id) {
      let counter = 0
      let pending = {}
      if (this.categoriesRelated.length > 0) {
        pending = this.categoriesRelated.filter((x) => x.category_id === id)
        if (this.filteredExpenseItems.length > 0) {
          let related = this.filteredExpenseItems.filter(
            (x) => x.gst_categories_id === id
          )
          counter = Object.keys(pending).length - Object.keys(related).length
        } else {
          counter = Object.keys(pending).length
        }
      }
      return counter
    },
    getTotal(type) {
      switch (type) {
        default:
        case 1:
          this.editedItem.total = this.editedItem.subtotal
          if(this.viewExpenseUniversal){
            this.editedItemReceiptUniversal.total = this.editedItemReceiptUniversal.subtotal
          }
          break
        case 2:
          this.editedItem.subtotal = this.editedItem.total
          if(this.viewExpenseUniversal){
            this.editedItemReceiptUniversal.subtotal = this.editedItemReceiptUniversal.total
          }
          break
        case 3:
          if(this.viewExpenseUniversal){
            let totalConcept = this.editedItemReceiptUniversal.item_lines.reduce((accumulator, item) => accumulator + parseFloat(item.amount), 0)
            if(totalConcept >= 0){
              // totalConcept * (this.editedItemReceiptUniversal.foreign_tax.percent / 100)
              this.editedItemReceiptUniversal.subtotal =  totalConcept
              // this.editedItemReceiptUniversal.total = totalConcept + ( totalConcept * (this.editedItemReceiptUniversal.foreign_tax.percent / 100))
              this.editedItemReceiptUniversal.total = totalConcept + ( totalConcept)
            }
          }
        break
      }
    },
    checkExpensesMessage() {
      var isNull = false
      this.filteredExpenseItems.forEach((item) => {
        if (item.subtotal == null) {
          isNull = true
        }
      })
      if (isNull) {
        return `<h5 class="mt-3"><i aria-hidden="true" class="v-icon material-icons theme--light mr-2">warning</i>${this.$t(
          'expenseItems.downloadProcess'
        )}</h5>`
      } else {
        return ``
      }
    },
    changeSort(header) {
      if (this.pagination.sortBy === header) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.descending = false
      }
      this.pagination.sortBy = header
    },
    expenseItemsFilter() {  
      this.sumaSubtotal = 0
      this.sumaDescuento = 0
      this.sumaTotal = 0
      this.filteredExpenseItems.forEach((value, index) => {
        this.sumaSubtotal +=
          value.subtotal != null ? parseFloat(value.subtotal) : parseFloat(0)
        this.sumaDescuento +=
          value.discount != null ? parseFloat(value.discount) : parseFloat(0)
        this.sumaTotal +=
          value.total != null
            ? parseFloat(value.total * value.exchange)
            : parseFloat(0)
      
      })
      
      this.checked = this.sumaTotal.toFixed(2)
      this.toCheck = (this.expenseAdvance - this.checked).toFixed(2)
      

    },
    isPDF(data) {
      if (data !== null) {
        let type = data.slice(data.indexOf('/') + 1, data.indexOf(';'))
        if (type === 'pdf') {
          return true
        } else {
          return false
        }
      }
    },
    openPDF() {
      var tab = window.open()
      tab.document.write(
        '<body style="margin: 0;"> <iframe src="' +
          this.dataURL +
          '" frameborder="0" style="margin: 0; padding: 0; border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;"</iframe></body>'
      )
    },
    countryFilter(item, queryText, itemText) {
      const description = item.descripcion.toLowerCase()
      const abbr = item.c_Pais.toLowerCase()
      const searchText = queryText.toLowerCase()
      return (
        description.indexOf(searchText) > -1 || abbr.indexOf(searchText) > -1
      )
    },
    currencyFilter(item, queryText, itemText) {
      const description = item.descripcion.toLowerCase()
      const abbr = item.c_Moneda.toLowerCase()
      const searchText = queryText.toLowerCase()
      return (
        description.indexOf(searchText) > -1 || abbr.indexOf(searchText) > -1
      )
    },
    deleteItem(item) {
      this.editedIndex = this.filteredExpenseItems.indexOf(item)
      this.editedItem = Object.assign({}, JSON.parse(JSON.stringify(item)))
      this.removeDialog = true
    },
    removeItem() {
      const item = this.editedItem
      let index = this.filteredExpenseItems.findIndex(function (o) {
        return o.id === item.id
      })
      if (index !== -1) this.filteredExpenseItems.splice(index, 1)
      this.delete()
    },
    closeRemove() {
      this.removeDialog = false
      this.editedItem = Object.assign(
        {},
        JSON.parse(JSON.stringify(this.defaultItem))
      )
      this.editedItemTip = Object.assign(
        {},
        JSON.parse(JSON.stringify(this.defaultItemTip))
      )
      this.editedIndex = -1
    },
    editItem(item, typeExpense) {
      if(this.viewExpenseUniversal && typeExpense === 3) {
        this.currencySeleted = item.currency.c_Moneda
        this.typeChange = item.currency.c_Moneda === this.currencySetting.value.c_Moneda ? '' : '(' + item.currency.c_Moneda + ' a ' + this.currencySetting.value.c_Moneda + ')'
        this.editItemUniversal(item)
        return
      }

      this.editedIndex = this.filteredExpenseItems.indexOf(item)
      this.editedItem = Object.assign({}, JSON.parse(JSON.stringify(item)))
      let id = this.editedItem.gst_expenses_items_files[0].files_id
      if (this.editedItem.country.id) {
        this.items.push(this.editedItem.country.id)
      }

      this.$store.dispatch('getFile', {
        event: {
          context: this,
          fileId: id,
        },
      })
      this.dialog = true
    },
    editItemUniversal(item) {
      this.editedIndex = this.filteredExpenseItems.indexOf(item)
      this.editedItemReceiptUniversal = Object.assign({}, JSON.parse(JSON.stringify(item)))

      if(this.editedItemReceiptUniversal.item_lines.length > 0){
        this.editedItemReceiptUniversal.item_lines.forEach(itemsLine => {
          itemsLine.line_taxes[0].amountText = (Number(itemsLine.amount) + Number(itemsLine.line_taxes[0].amount)).toFixed(2)
          itemsLine.line_taxes[0].amountExchange = (Number(itemsLine.line_taxes[0].amountText) * Number(this.editedItemReceiptUniversal.exchange)).toFixed(2)
        })
        this.editedItemReceiptUniversal.subtotal = this.editedItemReceiptUniversal.item_lines.reduce((total, line) => total + line.amount, 0).toFixed(2);
        this.editedItemReceiptUniversal.total = this.editedItemReceiptUniversal.item_lines.reduce((total, line) => total + line.amount + line.line_taxes[0].amount, 0).toFixed(2);
      }

      if(this.editedItemReceiptUniversal.vendor.id > 0) {
        this.editedItemReceiptUniversal.vendorSelect = this.editedItemReceiptUniversal.vendor.name
        this.editedItemReceiptUniversal.vendor.is_foreign = this.editedItemReceiptUniversal.vendor.is_foreign === 0
      }
      
      let id = this.editedItemReceiptUniversal.gst_expenses_items_files[0].files_id
      this.dialogUniversalExpense = true
      
      if (this.editedItemReceiptUniversal.country.id) {
        this.items.push(this.editedItem.country.id)
      }

      this.$store.dispatch('getFile', {
        event: {
          context: this,
          fileId: id,
        },
      })
    },
    // Close modal dialog
    closeDialogExpenseUniversal(){
      if (this.$refs.formExpenseUniversal) this.$refs.formExpenseUniversal.resetValidation() 
      this.dialogUniversalExpense = false
      this.editedItemReceiptUniversal = Object.assign(
        {},
        JSON.parse(JSON.stringify(this.editedItemReceiptUniversalDefault))
      )
      this.editedIndex = -1
      this.viewImg = false
      this.dataURL = null
      this.cfdiDialog = false//??
      this.errorConcepts = false
      if (this.$refs.dropzoneUniversal !== undefined) {
        this.$refs.dropzoneUniversal.removeAllFiles()
      }
    },
    closeDialog() {
      this.dialog = false
      this.editedItem = Object.assign(
        {},
        JSON.parse(JSON.stringify(this.defaultItem))
      )
      this.editedIndex = -1
      this.reset()
      this.closeCfdiDialog()
    },
    closeDialogTip() {
      this.dialogTip = false
      this.editedItemTip = Object.assign(
        {},
        JSON.parse(JSON.stringify(this.defaultItemTip))
      )
      this.editedIndexTip = -1
      this.reset()
    },
    // Reset the current form
    reset() {
      if (this.errors) this.errors = {}
      if (this.$refs.form) this.cleanFormNoFiscal()
      if (this.$refs.formCfdiDialog) this.$refs.formCfdiDialog.resetValidation()
      if (this.$refs.formExpenseUniversal) this.cleanFormExpenseUniversal() // SERIA RESET SI SE NECESITA QUE SE LIMPIEN TODOS LOS CAMPOS
      if (this.$refs.dropzoneNfiscal !== undefined) this.$refs.dropzoneNfiscal.removeAllFiles()
      if (this.$refs.dropzone !== undefined) this.$refs.dropzone.removeAllFiles()
      if (this.$refs.dropzoneUniversal !== undefined) this.$refs.dropzoneUniversal.removeAllFiles()
      
      this.viewImgU = false
      this.dataURL = null
    },
    cleanFormNoFiscal(){
      this.$refs.form.resetValidation()
      this.editedItem = this.defaultItem
      // this.editedItem.country = {}
      // this.editedItem.currency = {}
    },
    cleanFormExpenseUniversal(){
      this.$refs.formExpenseUniversal.resetValidation()
      this.editedItemReceiptUniversal = this.editedItemReceiptUniversalDefault
      // this.editedItemReceiptUniversal.country = {}
      // this.editedItemReceiptUniversal.currency = {}
      // this.editedItemReceiptUniversal.exchange = ''
    },
    // If the form is valid, post it
    submit() {
      if (
        (this.$refs.form && this.$refs.form.validate()) ||
        (this.$refs.formCfdiDialog && this.$refs.formCfdiDialog.validate())
      ) {
        this.loading = true
        if (this.editedItem.id !== undefined) {
          this.put()
        } else {
          if (
            this.editedItem.fileId !== null &&
            this.editedItem.fileId !== undefined
          ) {
            this.post()
          } else {
            this.loading = false
            this.showNotification(
              this.$t('expenseItems.noFileUploaded'),
              'error',
              -1
            )
          }
        }
      }
    },
    submitExpenseUniversal() {
      if(this.editedItemReceiptUniversal.item_lines.length === 0){
        this.showNotification( this.$t('expenses.errorCountConcept'), 'error', -1)
        return
      }

      if(this.editedItemReceiptUniversal.item_lines.length > 0){
        let error = 0

        this.editedItemReceiptUniversal.item_lines.forEach(function(item) {
          if(item.line === '') return error = 1
          if(item.amount <= 0) return error = 2
          if(item.gst_category_id === null || item.gst_category_id === undefined) return error = 3
        })

        this.errorConcepts = error > 0
        if(error > 0){
          switch (error) {
            case 1: return this.showNotification(this.$t('expenses.errorCountConceptLine'), 'error', -1)

            case 2: return this.showNotification(this.$t('expenses.errorCountConceptAmount'), 'error', -1)

            case 3: return this.showNotification(this.$t('expenses.errorCountConceptCategory'), 'error', -1)
          }
        }

      }

      if(this.editedItemReceiptUniversal.id ===  undefined && (this.editedItemReceiptUniversal.fileId === null || this.editedItemReceiptUniversal.fileId === undefined)){
        this.showNotification( this.$t('expenseItems.noFileUploaded'), 'error', -1)
        return
      }
      
      if(!this.errorConcepts && this.$refs.formExpenseUniversal && this.$refs.formExpenseUniversal.validate()){
        this.loading = true
        // this.editedItemReceiptUniversal.foreign_tax.amount = this.editedItemReceiptUniversal.total * (this.editedItemReceiptUniversal.foreign_tax.percent / 100)
        if(this.editedItemReceiptUniversal.id > 0){
          this.$emit('put', { item: this.editedItemReceiptUniversal, index: this.editedIndex, context: this})
        }
        else{
          this.$emit('post', { item: this.editedItemReceiptUniversal, context: this, expense_id: this.expense_id, has_next: this.uploadIndex + 1 < this.uploadedXML.length })
        }
      }else{
        this.showNotification(this.$t('general.validationError'), 'error', -1)
      }

    },
    defaultDeleteConcept(){
      this.itemDeleteConcept = {}
      this.deleteConceptConfirm = false
    },
    deleteConcept(item, index){
      if(item.id === undefined || item.id === 0 )
      {
        this.editedItemReceiptUniversal.item_lines.splice(index, 1)
        this.getTotal(3)
        return
      }

      this.itemDeleteConcept = item
      this.deleteConceptConfirm = true
    },
    deleteConceptConfirmed(){
      this.$emit('deleteConcept', {
        id: this.itemDeleteConcept.id,
        context: this,
      })
    },
    updateDataUniversal(response){
      this.editedItemReceiptUniversal.item_lines = response.data.data.lines
      this.getTotal(3)
      let universal = this.filteredExpenseItems.find(x => x.id === this.itemDeleteConcept.gst_expenses_item_id)
      universal.item_lines = response.data.data.lines
      this.defaultDeleteConcept()
    },
    submitTip() {
      if (this.$refs.tipForm.validate()) {
        this.loading = true
        if (
          this.editedItemTip.fileId !== null &&
          this.editedItemTip.fileId !== undefined
        ) {
          this.postTip()
        } else {
          this.loading = false
          this.showNotification(
            this.$t('expenseItems.noFileUploaded'),
            'error',
            -1
          )
        }
      }
    },
    // Close modal dialog
    closeDialogXML() {
      this.dialogXML = false
      this.loadingFile = false
      this.editedItem = Object.assign(
        {},
        JSON.parse(JSON.stringify(this.defaultItem))
      )
      this.editedIndex = -1
      this.uploadedXML = []
      this.uploadIndex = -1
      this.resetXML()
    },
    // Reset the current form
    resetXML() {
      this.selectXml = true
      this.readXml = null
      this.errors = {}
      this.uploadedXML = []
      this.uploadIndex = -1
      this.loadingFile = false
      this.$refs.formXML.resetValidation()
      if (this.$refs.dropzoneXML !== undefined) {
        this.$refs.dropzoneXML.removeAllFiles()
      }
    },
    submitXML() {
      let isFormXMLValid = true;
      let isFormXMLConceptsValid = true;
      if (!this.$refs.formXML.validate()) {
        this.showNotification(this.$t('expenses.commentRequired'), 'error', -1)
        isFormXMLValid = false;
      }
      if (this.$refs.formXMLConcepts && !this.$refs.formXMLConcepts.validate()) {
        this.showNotification(this.$t('expenses.errorConcept'), 'error', -1)
        isFormXMLConceptsValid = false;
      }
      if (isFormXMLValid && isFormXMLConceptsValid) {
        if (typeof this.editedItem.gst_categories === 'object') {
          this.editedItem.gst_categories_id = this.editedItem.gst_categories.id;
        } else {
          this.editedItem.gst_categories_id = this.editedItem.gst_categories;
        }
        if (this.$refs.formXML.validate()) {
          this.loading = true;
          this.loadingFile = false;
          this.post();
          this.nextXml = true;
        }
      }
    },
    xmlUpload(file, response) {
      this.loadingFile = true
      this.uploadedXML.push(response.data)
    },
    xmlQueueComplete() {
      this.selectXml = false
      this.uploadIndex = 0
      this.parseXml(this.uploadedXML[0].id)
    },
    fileAdded(file) {
      this.dropzoneOptions.params.user_id = this.$store.state.userLogged.id
      let fileType = file.type
      if (fileType === 'image/jpeg') {
        this.dropzoneOptions.params.files_type_id = 5
      } else if (fileType === 'image/png') {
        this.dropzoneOptions.params.files_type_id = 6
      } else if (fileType === 'application/pdf') {
        this.dropzoneOptions.params.files_type_id = 3
      }
    },
    fileUploadUniversal(file, response){
      this.editedItemReceiptUniversal.fileId = response.data.id
    },
    fileUpload(file, response) {
      this.editedItem.fileId = response.data.id
    },
    fileUploadTip(file, response) {
      this.editedItemTip.fileId = response.data.id
    },
    fileUploadError(file, message, xh) {
      this.showNotification(message, 'error', -1)
      this.errorMessage = message.errors.path[0]
      //   this.$refs.dropzoneXML = message.errors.path[0]
    },
    fileAddedXml(file) {
      this.dropzoneOptionsXML.params.user_id = this.$store.state.userLogged.id
    },
    parseXml(id) {
      this.$store.dispatch('expensesItems/readXmlQueueItem', {
        event: {
          file_id: id,
          context: this,
        },
      })
    },
    // DECRAPED METHOD
    getXml(id) {
      this.$store.dispatch('expensesItems/getXmlread', {
        event: {
          fileId: id,
          context: this,
        },
      })
    },
    showNextUpload() {
      this.errors.date = []
      this.nextXml = false
      this.readXml = null
      this.uploadIndex += 1
      if (this.uploadIndex < this.uploadedXML.length) {
        this.parseXml(this.uploadedXML[this.uploadIndex].id)
      } else {
        this.closeDialogXML()
        this.refresh()
      }
    },
    getSatFormaPago(value) {
      return this.satFormaPago.find((e) => value === '08' ?
        e.c_FormaPago === '07' : e.c_FormaPago === value
      )
    },
    getSatMetodoPago(value) {
      return this.satMetodoPago.find(
        (element) => element.c_MetodoPago === value
      )
    },
    getCurrency(value) {
      debugger;
      return this.satMoneda.find((element) => element.c_Moneda === value)
    },
    getCountry(value) {
      return this.satPais.find((element) => element.c_Pais === value)
    },
    // Click on file input
    pickFile() {
      this.$refs.file.click()
    },
    // Process the selected file on file input
    onFilePicked(e) {
      const files = e.target.files
      if (files[0] !== undefined) {
        this.fileName = files[0].name
        if (this.fileName.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.fileUrl = fr.result
          this.file = files[0] // this is an image file that can be sent to server
        })
      } else {
        this.fileName = ''
        this.file = ''
        this.fileUrl = ''
      }
    },
    closeCfdiDialog() {
      this.nextXml = false,
      this.cfdiDialog = false
      this.editedItem = Object.assign(
        {},
        JSON.parse(JSON.stringify(this.defaultItem))
      )
    },
    get() {
      this.$emit('get', {
        context: this,
        expense_id: this.expense_id,
      })
    },
    getExpenseById(){
      this.$emit('getExpenseById', {
        context: this,
        expense_id: this.expense_id,
      })
    },
    getCategoriesRelated(requestId) {
      this.$emit('getCategoriesRelated', {
        context: this,
        request_id: requestId,
      })
    },
    post() {
      if (this.editedItem.gst_receipt_types_id === 1 && this.editedItem.conceptos !== undefined && this.editedItem.conceptos.length > 0) {
        let item_lines = [];
        this.editedItem.conceptos.forEach(element => {
          let item = {};
          item.gst_category_id = element.gst_category_id;
          item.unit_code = element.ClaveUnidad;
          item.product_code = element.ClaveProdServ;
          item.amount = element.Importe;
          item.line = element.Descripcion;
          item_lines.push(item);
        });
        if (this.applyFeatures) {
          this.editedItem.item_lines = item_lines;
        } else {
          this.editedItem.item_lines = [];
        }
      }

      this.$emit('post', {
        item: this.editedItem,
        context: this,
        expense_id: this.expense_id,
        has_next: this.uploadIndex + 1 < this.uploadedXML.length,
      });
    },

    postTip() {
      if (
        this.editedItemTip.amount !== null &&
        this.editedItemTip.fileId !== null
      ) {
        this.$emit('postTip', {
          item: this.editedItemTip,
          context: this,
        })
      }
    },
    postTipExpense(expenseId) {
      if (
        this.editedItemTip.amount !== null &&
        this.editedItemTip.fileId !== null
      ) {
        this.editedItemTip.id = expenseId
        this.$emit('postTip', {
          item: this.editedItemTip,
          context: this,
        })
      }
    },
    put() {
      this.$emit('put', {
        item: this.editedItem,
        index: this.editedIndex,
        context: this,
      })
    },
    delete() {
      this.$emit('delete', {
        item: this.editedItem,
        index: this.editedIndex,
        context: this,
      })
    },
    readXmlToHtml(item) {
      const taxID = this.$store.state.userLogged.company[0].tax_id
      if (
        taxID === 'ING1811295P0' &&
        item.sat_formaPago_id !== null &&
        item.uuid === null
      ) {
        this.editItem(item)
        return
      }

      this.addTipExpense(item)
      if (item.gst_expenses_items_files.length > 0) {
        this.editedItem = item
        this.$store.dispatch('readXmlToHtml', {
          event: {
            id: item.gst_expenses_items_files[0].files_id,
            context: this,
          },
        })
      }
    },
    refresh() {
      this.$emit('refresh', {
        context: this,
        expense_id: this.expense_id,
      })
    },
    querySelection(val) {
      this.items = this.dataArrayFilter.querySelection(this.satPais, val)
    },
    currencyFormat(val) {
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
      })
      return formatter.format(val)
    },
    attachFiles(item) {
      this.$router.push('/expenses/files/attach/' + item.id)
    },
    amountMXN(amount, exchange) {
      if (amount === '') {
        amount = 0
      }
      return (amount * exchange).toFixed(2)
    },
    showTip(item) {
      let category = ''
      let type = ''
      
      if(this.viewExpenseUniversal && item.receipt_type.id === 3) return false

      if (item.gst_categories !== null) {
        category = item.gst_categories.name
      }
      if (item.receipt_type !== null) {
        type = item.receipt_type.name
      }
      const regex = new RegExp(category, "gi");

      if (regex.test('comida') || regex.test('hotel') || regex.test('alimentos') && type === 'fiscal') {
        return true
      } else {
        return false
      }
    },
    addTip(item) {
      this.editedItemTip.id = item.id
      this.getTip(item)
      this.dialogTip = true
    },
    addTipExpense(item) {
      this.editedItemTip.id = item.id
      this.getTip(item)
    },
    getTip(item) {
      this.$emit('getTip', {
        context: this,
        id: item.id,
      })
    },
    getFile(fileId) {
      this.$store.dispatch('getFile', {
        event: {
          context: this,
          fileId: fileId,
        },
      })
    },
    downloadRequest(item) {
      this.loadingDownload = true
      this.$emit('downloadRequest', {
        context: this,
        expensesRequest: item.travel_expenses_request.id,
        folio: item.travel_expenses_request.folio,
      })
    },
    openReceiptDialog () {
      this.editedItem.sat_forma_pago.id = 1
      this.editedItem.date = this.expense.start_date
      if(this.existFeature('DEFAULT_CATEGORY_REFUND') && parseFloat(this.expense.advance) <= 0 && this.expense.petty_cash_type === 0) this.editedItem.gst_categories_id = parseInt(this.$store.state.userLogged.company[0].features.find(x => x.name === 'DEFAULT_CATEGORY_REFUND').pivot.param1)

      if(this.existFeature('DEFAULT_CATEGORY_TRAVEL_EXPENSE') && this.expense.is_imported_expense === 1) this.editedItem.gst_categories_id = parseInt(this.$store.state.userLogged.company[0].features.find(x => x.name === 'DEFAULT_CATEGORY_TRAVEL_EXPENSE').pivot.param1)
      
      this.dialog = true
    },
    existFeature(feature){
      if(this.$store.state.userLogged.company === undefined) return false

      if(this.$store.state.userLogged.company[0].features.find(x => x.name === feature)) return true

      return false
    },
    openDialogUniversalExpense () {
      this.dialogUniversalExpense = true;
      this.editedItemReceiptUniversal.date = this.expense.start_date
      this.currencySeleted = this.editedItem.currency.c_Moneda
      this.typeChange = this.currencySetting.value.c_Moneda === this.editedItem.currency.c_Moneda ? '' : '(' + this.editedItem.currency.c_Moneda + ' a ' + this.currencySetting.value.c_Moneda + ')'
    },
    handleCheckboxChange(){
      if(!this.editedItemReceiptUniversal.vendor.is_foreign) this.resetDataVendor()
    },
    handleAutocompleteInput() {
      if(typeof this.editedItemReceiptUniversal.vendorSelect === 'object' && this.editedItemReceiptUniversal.vendorSelect !== null){
        this.editedItemReceiptUniversal.vendor = { ...this.editedItemReceiptUniversal.vendorSelect }
        this.editedItemReceiptUniversal.vendor.is_foreign = this.editedItemReceiptUniversal.vendor.is_foreign === 0
        this.disabledCheckIsNational = true
        return
      }

      this.disabledCheckIsNational = false
      this.resetDataVendor()
    },
    handleAutocompleteInputEdit(selectedItem){
      const selectedVendor = this.vendors.find(x => x.id === selectedItem);
      this.editedItemReceiptUniversal.vendor = { ...selectedVendor }
      this.editedItemReceiptUniversal.vendor.is_foreign = this.editedItemReceiptUniversal.vendor.is_foreign === 0
    },
    resetDataVendor(){
      this.editedItemReceiptUniversal.vendor.id = 0
      this.editedItemReceiptUniversal.vendor.tax_id = ''
      this.editedItemReceiptUniversal.vendor.tax_id_validation_numbers = ''
    },
    getCategoryAutomatic(phrase){
      const palabras = phrase.toLowerCase().split(/\s+/)

      for (const palabra of palabras) {
        const encontrado = this.keywordsFilter.find(item => item.keyword.toLowerCase() === palabra);
        if (encontrado) {
          return encontrado.gst_categories_id;
        }
      }

      return null
    },
    handleInputChange(value, item) {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      
      let categories = 0
      this.timer = setTimeout(() => {
        categories = this.getCategoryAutomatic(value)
        if(categories > 0) item.gst_category_id = categories
        else item.gst_category_id = item.gst_category_id || null
      }, 500)
    },
    handleInputAmounts(line, exchange){
      const iva = this.getAmountIva(line.amount, line.line_taxes[0].rate)
      line.line_taxes[0].amount = iva 
      line.line_taxes[0].amountText = (Number(line.amount) + Number(iva)).toFixed(2)
      line.line_taxes[0].amountExchange = (Number(line.line_taxes[0].amountText) * Number(exchange)).toFixed(2)
      this.getAmountUniversal()
    },
    getAmountIva(monto, iva){
      const porcentaje = iva > 0 ? (iva / 100) : 0
      return iva > 0 ? (monto * porcentaje) : 0
    },
    getAmountUniversal(){
      let total = 0
      let subtotal = 0

      this.editedItemReceiptUniversal.item_lines.forEach(item => {
        subtotal = Number(subtotal) + Number(item.amount)
        total = Number(total) + Number(item.line_taxes[0].amountText)
      })
      this.editedItemReceiptUniversal.subtotal = Number(subtotal)
      this.editedItemReceiptUniversal.total = Number(total)
    },
    handleInputExchange(item){
      if(item.item_lines.length === 0 ) return
      
      item.item_lines.forEach(itemLine => {
        if(itemLine.amount > 0) this.handleInputAmounts(itemLine, item.exchange)
      })
    }
  }
}
</script>

<style>
  .grey-row {
    background-color: #f5f5f5; /* Color gris claro */
  }
  .white-row {
    background-color: #ffffff; /* Color blanco */
  }
  .totals-row {
      height: 15px; /* Ajusta esta altura según tus necesidades */
      padding: 0;
  }
  .totals-row td {
    padding: 0 5px;
    font-size: 12px; /* Ajusta el tamaño de la fuente si es necesario */
    line-height: 15px; /* Asegura que el texto esté centrado verticalmente */
  }
  .totals-row .v-btn {
    min-width: 15px;
    height: 15px;
    width: 15px;
  }
  .dynamic-textarea {
    max-height: 4em; /* Altura máxima deseada (3 líneas) */
    overflow-y: auto; /* Agregar barra de desplazamiento vertical cuando se exceda la altura máxima */
  }
  .red-text {
    color: #b71c1c ;
  }
  .custom-row-color {
    background-color:rgba(137, 119, 240, 0.322);
  }
  .alertValidate {
    padding: 5px; 
    border-radius: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/expense.item.component.vue